// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:39:21.405Z
// Property: Artistry at Bethesda Park (ID: 5670511623274496)
// Collections: 21 amenities, 6 floorplans (live), 37 photos, 83 POIs, 4 reviews, 1 virtual tours, 6 office hours, 1 special offers (live), 18 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5670511623274496",
  "property_external_id": "4881699",
  "property_zillow_url": "https://www.zillow.com/apartments/lawrenceville-ga/artistry-at-bethesda-park/5XhtTj/",
  "property_apartments_url": "https://www.apartments.com/artistry-at-bethesda-park-lawrenceville-ga/rmlx2q1",
  "property_google_business_url": "https://www.google.com/maps/place/Artistry+at+Bethesda+Park/@33.9047105,-84.0811576,15z/data=!4m2!3m1!1s0x0:0xb52f70692497a5dc?sa=X&ved=2ahUKEwieuLLhz-H2AhXTnGoFHVp2CrsQ_BJ6BAgkEAU",
  "property_linkedin_url": null,
  "property_hubspot_id": "8443201069",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "artistry-at-bethesda-park",
  "property_name": "Artistry at Bethesda Park",
  "property_website_url": "https://www.artistryatbp.com/",
  "property_domain": "https://www.artistryatbp.com/",
  "property_address": "156 Bethesda Church Rd",
  "property_full_address": "156 Bethesda Church Rd, Lawrenceville, GA 30044",
  "property_address_1": "156 Bethesda Church Rd",
  "property_address_2": null,
  "property_address_city": "Lawrenceville",
  "property_address_state": "GA",
  "property_address_zip_full": "30044-6413",
  "property_address_zip": "30044",
  "property_address_country": "US",
  "property_address_county": "Gwinnett County",
  "property_neighborhood_address": "Outer Gwinnett County",
  "property_address_latitude": "33.9049448",
  "property_address_longitude": "-84.08221019999999",
  "property_email": "artistry@alapts.com",
  "property_phone": "(770) 921-7794",
  "property_call_tracking_phone": "770-796-4682",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Parkside calm, polished apartment living.</strong> Explore renovated one-, two-, and three-bedroom homes near Bethesda Park, with open layouts, stainless-steel appliances, hardwood-style flooring, generous storage, and private outdoor space in select homes—then browse available floor plans to find your fit.</p>",
  "property_long_description": "<p><strong>Parkside calm with Lawrenceville convenience.</strong> At Artistry at Bethesda Park, you get renovated one-, two-, and three-bedroom apartments set among rolling green space just moments from Bethesda Park’s trails, lake loop, sports fields, playgrounds, and indoor aquatic center. Inside, open-concept layouts pair everyday function with polished finishes like stainless-steel appliances, kitchen islands or peninsulas, pantry storage, hardwood-style flooring, large closets, and private patios or balconies in select homes.</p><p>Beyond your front door, <a href=\"/amenities\">community amenities</a> bring a resort-inspired feel to the day: a sun-splashed pool, courtyard grilling area, fire pit, fitness center, game room, package system, bark park, and dog spa. When you want more to explore, Downtown Lawrenceville is a short drive away for the Lawrenceville Arts Center, Aurora Theatre, Local Republic, Strange Taco Bar, and the historic square, while nearby Pleasant Hill Road, Sugarloaf Parkway, and Atlanta-area routes keep shopping, dining, and regional destinations within easy reach. Browse <a href=\"/floor-plans\">available floor plans</a> and find the space that fits how you live.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019d02f0-a7f6-731e-8be9-a74bdb1007a1.webp",
  "property_featured_image_media": {
    "alt_text": "Modern living room with gray sofa, abstract art, and a coffee table.",
    "public_id": "019d02f0-a7f6-731e-8be9-a74bdb1007a1",
    "storage_key": "property/5670511623274496/019d02f0-a7f6-731e-8be9-a74bdb1007a1.webp",
    "width": 1240,
    "height": 826
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "222",
  "property_year_built": "2001",
  "property_year_renovated": "2021",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.74774774774775",
  "property_admin_fee": "225",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Pet Fee: $350/pet non-refundable\nMonthly Pet Rent: $25/pet",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $350 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $350 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8778160.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://artistry.loftliving.com/login",
  "property_apply_now_url": "https://8778160.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019df5d3-6b3c-70af-9931-4b43ad4867b3.webp",
  "property_primary_logo_media": {
    "alt_text": "Artistry at Bethesda Park logo",
    "public_id": "019df5d3-6b3c-70af-9931-4b43ad4867b3",
    "storage_key": "property/5670511623274496/019df5d3-6b3c-70af-9931-4b43ad4867b3.webp",
    "width": 741,
    "height": 516
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019d02f0-9b01-7622-a1cf-0cb450192c43.webp",
  "property_secondary_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02f0-9b01-7622-a1cf-0cb450192c43",
    "storage_key": "property/5670511623274496/019d02f0-9b01-7622-a1cf-0cb450192c43.webp",
    "width": 325,
    "height": 147
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019df5d3-6af6-71f8-b688-7b51d804c909.webp",
  "property_icon_media": {
    "alt_text": "Artistry logo",
    "public_id": "019df5d3-6af6-71f8-b688-7b51d804c909",
    "storage_key": "property/5670511623274496/019df5d3-6af6-71f8-b688-7b51d804c909.webp",
    "width": 1002,
    "height": 1001
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019df5d3-6af6-71f8-b688-7b51d804c909.webp",
  "property_fav_icon_media": {
    "alt_text": "Artistry logo",
    "public_id": "019df5d3-6af6-71f8-b688-7b51d804c909",
    "storage_key": "property/5670511623274496/019df5d3-6af6-71f8-b688-7b51d804c909.webp",
    "width": 1002,
    "height": 1001
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1560-8e2d-773d-ba6f-24d79482100a.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019f1560-8e2d-773d-ba6f-24d79482100a",
    "storage_key": "property/5670511623274496/019f1560-8e2d-773d-ba6f-24d79482100a.webp",
    "width": 741,
    "height": 516
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1560-8254-71fc-b6eb-676e9d158fdc.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019f1560-8254-71fc-b6eb-676e9d158fdc",
    "storage_key": "property/5670511623274496/019f1560-8254-71fc-b6eb-676e9d158fdc.webp",
    "width": 741,
    "height": 516
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#fda329",
  "property_secondary_color": "#474747",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#6e6e6e",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "840 - 1492",
  "property_sqft_min": "840",
  "property_sqft_max": "1492",
  "property_price_range": "1368.33 - 2075",
  "property_price_min": "1368.33",
  "property_price_max": "2075",
  "property_available_units": 5,
  "property_facebook_url": "https://www.facebook.com/ArtistryatBethesdaPark",
  "property_instagram_url": "https://www.instagram.com/artistryatbethesdaparkapts",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJKQPb1EO79YgR3KWXJGlwL7U",
  "property_youtube_url": "https://www.youtube.com/@ArtistryatBethesdaPark",
  "property_yelp_url": "https://www.yelp.com/biz/park156-lawrenceville",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Amenities with an easy rhythm.</strong> At Artistry at Bethesda Park, daily convenience meets room to unwind: secure package pickup, online resident services, a pool, fire pit, courtyard gathering space, fitness center, and game room. Pet-friendly perks include a dog park and dog spa, while renovated interiors add hard-surface flooring in select homes, modern appliances, tile backsplash details, USB outlets, blinds, and in-home laundry.</p>",
  "property_home_floorplans_blurb": "<p><strong>Renovated layouts with room to choose.</strong> Explore one-, two-, and three-bedroom apartments in Lawrenceville with open living areas, stainless-steel appliances, kitchen islands or peninsulas, pantry storage, and polished finishes. Select homes add large closets, hardwood-style flooring, in-home laundry, and a private patio or balcony.</p>",
  "property_home_gallery_blurb": "<p><strong>Preview life in a greener frame.</strong> The gallery at Artistry at Bethesda Park captures renovated interiors with sunlit living spaces, stainless-steel kitchens, and island or peninsula workspace, plus a garden-style setting shaped by courtyards and open air.</p><p>Scroll from the pool and sun deck to the grilling area, fire pit, clubhouse, fitness center, and pet-friendly spaces—then view the full gallery to see more of the community up close.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Lawrenceville ease, Gwinnett access.</strong> Artistry at Bethesda Park puts lake trails and green space at Bethesda Park close to home, with Ronald Reagan Parkway nearby for simple cross-county trips. Evenings can lead to Downtown Lawrenceville’s patios, performance venues, BBQ, taverns, and Slow Pour Brewing, while Sugarloaf Mills brings shopping, dining, and entertainment near I-85.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents praise the calm, clean feel</strong> at Artistry at Bethesda Park, along with quick maintenance and a leasing team known for thoughtful communication. Reviews often mention Kiara by name for making move-in feel smooth and clear. Spacious apartments, a well-equipped fitness center, outdoor spaces, and a dog park round out the everyday details residents appreciate—especially the “peace and quietness” that makes the community stand out.</p>",
  "property_neighborhood_blurb": "<p><strong>Map out a Lawrenceville day with room to roam.</strong> From Artistry at Bethesda Park, the neighborhood feels easygoing and connected: start with the lake trail and open green space at Bethesda Park, swing onto Ronald Reagan Parkway for a straightforward drive across Gwinnett, then head toward Downtown Lawrenceville when the evening calls for patios, live performance, and local flavor. Oyster Bay, Dominick’s, Foggy Bottom BBQ, McCray’s Tavern, and Slow Pour Brewing give the square a casual, come-and-stay-awhile energy, while Sugarloaf Mills adds outlet shopping, dining, and entertainment close to I-85. Back at home, <a href=\"/amenities\">pet-friendly amenities</a> and polished community spaces keep the day’s best moments close.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Comfort that keeps pace.</strong> At Artistry at Bethesda Park, amenities move smoothly from practical to polished: pick up deliveries on your schedule with the package system, handle everyday tasks through online resident services, then unwind by the pool, around the fire pit, or in the courtyard’s open-air gathering space. When you want to reset, the fitness center and game room keep options close to home, while the dog park and dog spa add thoughtful perks for pet-friendly apartment living in Lawrenceville. Inside, renovated finishes bring the same easy feel with hard-surface flooring in select homes, modern kitchen appliances, pantry closets, tile backsplash details, USB outlets, blinds, and in-home laundry. Explore the <a href=\"/gallery\">community spaces</a>, then <a href=\"/schedule-a-tour\">see the amenities in person</a>.</p>",
  "property_applynow_blurb": "<p><strong>Ready for parkside calm and everyday convenience?</strong> Start your application for a renovated one-, two-, or three-bedroom apartment at Artistry at Bethesda Park, where open layouts, polished finishes, and green-space surroundings make home feel easy. Explore <a href=\"/floor-plans\">available floor plans</a>, then apply online when you find your fit.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Reach out to the Artistry at Bethesda Park leasing team for help finding your way, exploring renovated one-, two-, and three-bedroom apartments, or learning more about parkside living with Lawrenceville convenience.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Artistry at Bethesda Park?</strong> Start here for quick answers on the community, leasing, amenities, and everyday living in our renovated Lawrenceville apartments near Bethesda Park. Explore details, then <a href=\"/contact-us\">connect with the leasing team</a> anytime—we’re happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Choose the layout that fits your rhythm.</strong> Artistry at Bethesda Park gives you a clear range of renovated one-, two-, and three-bedroom apartments in Lawrenceville, from streamlined one-bedroom designs to roomier two-bedroom homes with paired baths and a three-bedroom option with extra flexibility. As you compare availability, look for open living areas, well-planned kitchens with stainless-steel appliances, islands or peninsulas, pantry storage, and finishes that keep each space feeling polished without feeling overdone.</p><p>Your floor plan can also bring practical details that matter day to day, including large closets, hardwood-style flooring, in-home laundry, and a private patio or balcony in select homes. Explore current pricing, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how each layout lives in person.</p>",
  "property_gallery_blurb": "<p><strong>See the setting, then picture the day.</strong> Browse the Photo Gallery for Artistry at Bethesda Park and get a closer look at renovated apartments, inviting community spaces, and the green, garden-style backdrop that shapes the experience. Photos highlight open living areas filled with natural light, polished kitchens with stainless-steel appliances and island or peninsula workspace, and bedrooms designed with a clean, comfortable finish.</p><p>Outside, follow the scene from the sun deck and pool to the courtyard grilling area, fire pit, clubhouse, fitness center, and pet-friendly spaces. When a photo sparks your interest, explore more <a href=\"/amenities\">amenity details</a>, compare <a href=\"/floor-plans\">available floor plans</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the community in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Map your next move.</strong> Explore available apartments at Artistry at Bethesda Park, then use the interactive map to see how rolling green space, Bethesda Park recreation, Downtown Lawrenceville, and nearby routes connect around you.</p>",
  "property_pets_blurb": "<p><strong>Room to sniff, stretch, and settle in.</strong> At Artistry at Bethesda Park, pet-friendly living feels built into the everyday—not tacked on. Start with an onsite bark park for quick play breaks, then use the dog spa when rainy walks or muddy paws follow you home. Around the community, landscaped green space and nearby park paths make it easy to add a little fresh air to the routine without turning every outing into a production.</p><p>Back inside, roomy one-, two-, and three-bedroom <a href=\"/floor-plans\">apartment layouts</a> give cats, dogs, and their favorite humans space to relax, while select patios or balconies offer an extra spot to enjoy the quiet. Explore more <a href=\"/amenities\">pet-friendly amenities</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how life with your companion fits here.</p>",
  "property_referafriend_blurb": "<p><strong>Share parkside calm with a friend.</strong> If you love Artistry at Bethesda Park’s renovated apartments, rolling green space, and resort-inspired community spaces, invite someone to experience it too. Send a referral today and help them find their next Lawrenceville home.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access made simple.</strong><br>Enjoy parkside calm and Lawrenceville convenience while managing the everyday details from home. Log in to pay rent, submit maintenance requests, and keep your Artistry at Bethesda Park account up to date.</p>",
  "property_reviews_blurb": "<p><strong>Real feedback, real everyday details.</strong> As you read the reviews for Artistry at Bethesda Park, you’ll see residents consistently call out a calm, clean setting, responsive maintenance, and a leasing team that communicates with care. Kiara earns repeated praise for making the process feel smoother, with one resident sharing that her “communication was beyond great.”</p><p>Residents also highlight beautiful, spacious apartments, a well-equipped fitness center, helpful outdoor spaces, and a dog park that adds to the community’s complete feel. If you’re weighing your next apartment, these reviews offer a grounded look at what living here can feel like—from quick service requests to the everyday “peace and quietness” residents appreciate.</p>",
  "property_created_at": "1752256458849",
  "property_scheduletour_blurb": "<p><strong>See parkside living up close.</strong> Tour renovated one-, two-, and three-bedroom apartments with open layouts, polished finishes, generous storage, and select private patios or balconies—then step into the green, resort-inspired setting that makes Artistry at Bethesda Park feel so easy to come home to.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — we’ve received your inquiry.</strong><br>Our leasing team will be in touch soon. In the meantime, Artistry at Bethesda Park offers renovated apartment living with open-concept layouts, polished finishes, and a parkside setting that keeps Lawrenceville convenience close.</p>",
  "property_virtualtours_blurb": "<p><strong>Take the community for a spin before you arrive.</strong> The Artistry At Bethesda virtual tour lets you explore the feel of Artistry at Bethesda Park from wherever you are, moving through the community at your own pace and seeing how the garden-style setting comes together on screen. Pause on the details that matter in a walkthrough—open outdoor areas, relaxed gathering spots, and the easy connection between everyday conveniences and places to unwind.</p><p>After your virtual look, keep planning your next step: compare <a href=\"/floor-plans\">one-, two-, and three-bedroom layouts</a>, browse the <a href=\"/gallery\">photo gallery</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the Lawrenceville community in person.</p>",
  "property_copyright": "2025 All Rights Reserved. Artistry at Bethesda Park",
  "property_seo_title_home": "Artistry at Bethesda Park | Apartments in Lawrenceville, GA",
  "property_seo_description_home": "Discover your perfect home at Artistry at Bethesda Park in Lawrenceville, GA! Our stunning one, two, and three-bedroom floor plans offer modern living with exceptional amenities like a resort-style pool, dog park, fitness center, and game room. Enjoy your private outdoor space, well-appointed kitchens, and sleek finishes, including tile backsplashes and hardwood floors. Experience a vibrant community with online resident services and a welcoming atmosphere. Find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Lawrenceville, GA",
  "property_seo_description_floorplans": "Discover your ideal living space at Artistry at Bethesda Park in Lawrenceville, GA! Explore our thoughtfully designed one, two, and three-bedroom floor plans tailored to fit your lifestyle. Whether you’re seeking cozy comfort or spacious living, we have the perfect home for you. Browse our available apartment homes today and find your perfect floor plan!",
  "property_seo_title_amenities": "Amenities | Lawrenceville, GA Apartments for Rent",
  "property_seo_description_amenities": "Discover the perfect blend of comfort and luxury at Artistry at Bethesda Park in Lawrenceville, GA. Explore a variety of spacious floor plans, including one, two, and three-bedroom options. Enjoy exceptional amenities like our state-of-the-art fitness center, inviting game room, and serene dog park—ideal for your furry friends! Relax by the fire pit or take a dip in our refreshing pool. With online resident services and stunning outdoor spaces, your new home awaits. Explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in Lawrenceville, GA",
  "property_seo_description_gallery": "Discover your dream home at Artistry at Bethesda Park in Lawrenceville, GA! With stunning one, two, and three-bedroom floor plans, you’ll find the perfect fit for your lifestyle. Enjoy resort-style amenities like a sparkling pool, fitness center, dog park, fire pit, and game room. Picture yourself living in a community that embraces comfort and convenience, featuring modern kitchens, ample storage, and beautiful outdoor spaces. Explore our photo gallery and envision your future today!",
  "property_seo_title_virtualtours": "Virtual Tours | Artistry at Bethesda Park Apartments",
  "property_seo_description_virtualtours": "Discover your perfect home at Artistry at Bethesda Park in Lawrenceville, GA! Explore our stunning one, two, and three-bedroom floor plans and experience community life like never before. Take a virtual tour today to see all that our inviting apartments have to offer. Don't miss out—find your ideal living space now!",
  "property_seo_title_interactivemap": "Interactive Map | Artistry at Bethesda Park Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Artistry at Bethesda Park in Lawrenceville, GA! Choose from spacious one, two, and three-bedroom floor plans, each equipped with modern amenities like a fitness center, dog park, and inviting courtyard. Enjoy luxury living with features like a fireplace, vaulted ceilings, and convenient online resident services. Explore our interactive community map to find available apartments, view pricing, and unlock your next chapter today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Lawrenceville, GA",
  "property_seo_description_neighborhood": "Discover vibrant living at Artistry at Bethesda Park in Lawrenceville, GA! Explore our diverse floor plans including one, two, and three-bedroom apartments. See what's around our community and uncover local favorites and nearby attractions. Your ideal neighborhood awaits—dive in today!",
  "property_seo_title_contact": "Contact Us | Artistry at Bethesda Park",
  "property_seo_description_contact": "Discover your perfect home at Artistry at Bethesda Park in Lawrenceville, GA! Explore our stunning floor plans featuring one, two, and three-bedroom apartments designed for comfort and style. Have questions? Contact our leasing team today to find the apartment that fits your lifestyle!",
  "property_seo_title_faqs": "FAQs | Apartments in Lawrenceville, GA",
  "property_seo_description_faqs": "Discover a vibrant lifestyle at Artistry at Bethesda Park in Lawrenceville, GA! Explore our diverse floor plans featuring one, two, and three-bedroom apartments designed for comfort. Enjoy top-notch amenities like a fitness center, game room, dog park, and a relaxing pool. Have questions? Browse our FAQs page for answers to everything about our community and experience luxury living today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Lawrenceville, GA",
  "property_seo_description_reviews": "Discover the unparalleled lifestyle at Artistry at Bethesda Park in Lawrenceville, GA. Explore our diverse range of floor plans all designed for your comfort—choose from one, two, or three-bedroom apartments. Enjoy top-tier amenities, including a fitness center, dog park, game room, and refreshing pool. Experience community living at its finest with online resident services and beautifully landscaped courtyards. Don’t just take our word for it—see what our residents have to say about life in our vibrant community! Come home to Artistry at Bethesda Park today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Lawrenceville, GA",
  "property_seo_description_applynow": "Discover your perfect home at Artistry at Bethesda Park in Lawrenceville, GA! Explore our spacious one, two, and three-bedroom floor plans and enjoy top-notch amenities like a state-of-the-art fitness center, dog park, and inviting fire pit. With features such as a modern kitchen, washer/dryer included, and serene park views, our community is designed for your comfort and lifestyle. Don't miss your chance to experience luxury living—apply online today and find your new home! ",
  "property_seo_title_residentaccess": "Resident Access | Artistry at Bethesda Park",
  "property_seo_description_residentaccess": "\"Login to the Resident Portal at Artistry at Bethesda Park in Lawrenceville, GA! Easily pay rent, schedule maintenance, and manage your apartment needs all in one place. Access your community resources now!\"",
  "property_seo_title_referafriend": "Refer A Friend | Artistry at Bethesda Park",
  "property_seo_description_referafriend": "🌟 Discover the beauty of community at Artistry at Bethesda Park in Lawrenceville, GA! Great friends make great neighbors—refer a friend today and share the vibrant lifestyle our apartment community has to offer. Enjoy exclusive perks and foster lasting connections in your new home! 🏡✨",
  "property_seo_title_scheduletour": "Schedule a Tour | Artistry at Bethesda Park",
  "property_seo_description_scheduletour": "Discover your dream home at Artistry at Bethesda Park in Lawrenceville, GA! Experience luxury living in our stunning apartments. Schedule a tour of our community today and envision your new lifestyle amidst beautiful surroundings and top-notch amenities!",
  "property_seo_title_privacy": "Privacy Policy | Artistry at Bethesda Park",
  "property_seo_description_privacy": "Discover how we safeguard your personal information at Artistry at Bethesda Park in Lawrenceville, GA. Your privacy matters to us! View our privacy policy to learn more about our commitment to protecting your data.",
  "property_seo_title_accessibility": "Website Accessibility | Artistry at Bethesda Park",
  "property_seo_description_accessibility": "\"Discover Artistry at Bethesda Park in Lawrenceville, GA, where we prioritize accessibility for all residents. Our commitment to digital inclusion ensures everyone can fully enjoy our vibrant community. Learn more about our accessibility features and join us in creating a welcoming space for everyone!\"",
  "property_seo_title_sitemap": "Sitemap | Artistry at Bethesda Park",
  "property_seo_description_sitemap": "Discover a world of comfort and style at Artistry at Bethesda Park in Lawrenceville, GA. Our sitemap makes it easy to explore our vibrant community, floor plans, and amenities. View our website sitemap to find your perfect home today!",
  "property_seo_title_thankyou": "Thank You | Artistry at Bethesda Park",
  "property_seo_description_thankyou": "Thank you for reaching out to Artistry at Bethesda Park in Lawrenceville, GA! We appreciate your interest and a member of our friendly team will be in touch shortly to assist you. Discover your future home in our vibrant community filled with modern amenities.",
  "property_seo_title_pets": "Pet Policy | Apartments in Riverview, FL",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793651137130",
  "amenities": [
    {
      "id": "custom_96bc074b-193b-46b2-8a68-ab84c91a8c30",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_89ce8705-af32-410f-8ed3-1afa13c1a6aa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "custom",
      "external_id": "P000000603",
      "title": "Blinds",
      "amount": "0.0000",
      "description": "2' Faux Wood Blinds",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5fd0da16-7150-4143-8da5-dd5ffc7812b9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Granite/Quartz Countertops",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_990a107b-b596-463a-bc38-b016518fa2c9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "custom",
      "external_id": "P000000622",
      "title": "Courtyard",
      "amount": "0.0000",
      "description": "Courtyard w/Grill Area",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_33756a3f-e0e7-45f1-9ab4-2b16c6b21504",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Bark Park for your Furry Friends",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4eac271e-d154-4c86-b94f-7d9eaf6c0e41",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "custom",
      "external_id": "P000000627",
      "title": "Dog Spa",
      "amount": "0.0000",
      "description": "Dog Spa",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b58c2eca-ed97-4b13-81c5-f46c96892962",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "custom",
      "external_id": "P000000633",
      "title": "Fire",
      "amount": "0.0000",
      "description": "Wood Burning Fireplace",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5df10c19-930e-4374-90e4-5f831f0a3953",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "custom",
      "external_id": "P000000634",
      "title": "Fire Pit",
      "amount": "0.0000",
      "description": "Community  Fire Pit",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9e51eba5-aa3a-42dd-9a5c-356b6101ade9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Modern 24-Hour Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_71df1b96-4bd0-4bed-a7c2-581ceab6adea",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "custom",
      "external_id": "P000000639",
      "title": "Game Room",
      "amount": "0.0000",
      "description": "Resident Gaming Room",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fa66a24f-a879-49ca-b10d-beaff349db51",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Hardwood Style Flooring*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7da18022-3c37-4355-82b8-564f713e99ef",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_07f06352-e956-47e6-9d8a-a8212c8bfc7c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_96baeb37-039d-4052-a6dd-7c03b9307c9b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private Patio/Balcony",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6fe184d2-422d-4337-9792-37402d3d2289",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "custom",
      "external_id": "P000000665",
      "title": "Package System",
      "amount": "0.0000",
      "description": "Amazon Hub Package System",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_df129f4c-611a-472b-be50-5a1218da6921",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "custom",
      "external_id": "P000000666",
      "title": "Pantry Closets",
      "amount": "0.0000",
      "description": "Large Closets w/Organizers",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_91c78f42-f8c3-45e7-a4ef-a1a8a76a5acc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort Inspired Pool",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3ae92ed6-d4e3-4fac-b321-cfbc0dccb284",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "custom",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*In Select Homes",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d5ca6301-7df6-4ab9-9ed0-0caa1284e81b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "custom",
      "external_id": "P000000695",
      "title": "Tile Backsplash",
      "amount": "0.0000",
      "description": "Kitchen Backsplash",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e1664163-9c53-4b5f-b93f-8750fdc8b3e9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "custom",
      "external_id": "P000000698",
      "title": "USB Outlet",
      "amount": "0.0000",
      "description": "USB Outlets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_85ec882b-03b9-4684-8488-1241bddae2d8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "In-Home Washer and Dryer*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_c7d08a2e-e094-4332-871e-61c1b692542b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1a4e-89c0-75e8-99ef-0e8152c56ed1.webp",
      "image_media": {
        "alt_text": "Lobby seating area with brown leather sofas, striped rug, and coffee station.",
        "public_id": "019f1a4e-89c0-75e8-99ef-0e8152c56ed1",
        "storage_key": "property/5670511623274496/019f1a4e-89c0-75e8-99ef-0e8152c56ed1.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax in our inviting lobby, featuring plush seating, a modern fireplace, and a convenient coffee station for your enjoyment.",
      "link": "",
      "alt_text": "Lobby seating area with brown leather sofas, striped rug, and coffee station.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e7498af1-e370-45f8-a604-6c29d6e55cb1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1a4e-4b89-7637-b0aa-a8bed53b791a.webp",
      "image_media": {
        "alt_text": "Community green space with a stone fire pit, outdoor fitness equipment, and apartment buildings under a blue sky.",
        "public_id": "019f1a4e-4b89-7637-b0aa-a8bed53b791a",
        "storage_key": "property/5670511623274496/019f1a4e-4b89-7637-b0aa-a8bed53b791a.webp",
        "width": 2732,
        "height": 1820
      },
      "title": "Community",
      "description": "Enjoy the expansive community green space featuring a charming stone fire pit, perfect for gatherings, and convenient outdoor fitness equipment. A beautiful setting to relax and stay active.",
      "link": "",
      "alt_text": "Community green space with a stone fire pit, outdoor fitness equipment, and apartment buildings under a blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_24dce3a4-e189-41b6-8eaa-7afde43a78f5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1a4e-2219-7432-a3d7-d1f115139d68.webp",
      "image_media": {
        "alt_text": "Aerial view of a community swimming pool area with lounge chairs, umbrellas, and a clubhouse building surrounded by lush trees.",
        "public_id": "019f1a4e-2219-7432-a3d7-d1f115139d68",
        "storage_key": "property/5670511623274496/019f1a4e-2219-7432-a3d7-d1f115139d68.webp",
        "width": 2732,
        "height": 1820
      },
      "title": "Community",
      "description": "Dive into relaxation at our inviting community pool. Enjoy the sun on comfortable lounge chairs under shade umbrellas, with convenient access to the elegant clubhouse amenities.",
      "link": "",
      "alt_text": "Aerial view of a community swimming pool area with lounge chairs, umbrellas, and a clubhouse building surrounded by lush trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ac4330cd-7e3c-40fd-b756-9b5b405bec44",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1a4e-7d8e-709b-a0e9-151b7f92e5b5.webp",
      "image_media": {
        "alt_text": "Dog park area with gazebo, pet waste station, and apartment buildings in the background.",
        "public_id": "019f1a4e-7d8e-709b-a0e9-151b7f92e5b5",
        "storage_key": "property/5670511623274496/019f1a4e-7d8e-709b-a0e9-151b7f92e5b5.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, complete with a shaded gazebo and convenient pet waste stations, making it easy to care for your furry friends.",
      "link": "",
      "alt_text": "Dog park area with gazebo, pet waste station, and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_391b4c2b-3779-43af-88b4-aecae7aa53d4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1a4e-6e60-74f1-8233-ebf014ad05fb.webp",
      "image_media": {
        "alt_text": "Outdoor recreational court with a playground and seating.",
        "public_id": "019f1a4e-6e60-74f1-8233-ebf014ad05fb",
        "storage_key": "property/5670511623274496/019f1a4e-6e60-74f1-8233-ebf014ad05fb.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy outdoor fun on our sports court, featuring a playground and ample space for recreation.",
      "link": "",
      "alt_text": "Outdoor recreational court with a playground and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_47f4e561-6738-4aa9-9a7c-ec0c6d63cb49",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1a4e-6a01-7381-ab3a-af6d45571cc5.webp",
      "image_media": {
        "alt_text": "Modern lounge area with stylish seating and a coffee bar.",
        "public_id": "019f1a4e-6a01-7381-ab3a-af6d45571cc5",
        "storage_key": "property/5670511623274496/019f1a4e-6a01-7381-ab3a-af6d45571cc5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and socialize in our beautifully designed community lounge, featuring comfortable seating, a modern coffee bar, and elegant decor.",
      "link": "",
      "alt_text": "Modern lounge area with stylish seating and a coffee bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7bccb72f-607d-4a4a-bc41-8d9b9a790f73",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1a4e-65f8-76cc-899e-b749f8199058.webp",
      "image_media": {
        "alt_text": "Picnic tables and fire pit in a grassy community area with trees and apartment buildings in the background.",
        "public_id": "019f1a4e-65f8-76cc-899e-b749f8199058",
        "storage_key": "property/5670511623274496/019f1a4e-65f8-76cc-899e-b749f8199058.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings at the picnic tables or gather around the fire pit in this beautiful community space, surrounded by lush greenery and apartment buildings.",
      "link": "",
      "alt_text": "Picnic tables and fire pit in a grassy community area with trees and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fb9b7a58-147c-477a-908a-07135f1b7438",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1a4e-5cf9-75bd-8c78-936e835477be.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, ellipticals, and weight machines. Doors lead to an outdoor pool area.",
        "public_id": "019f1a4e-5cf9-75bd-8c78-936e835477be",
        "storage_key": "property/5670511623274496/019f1a4e-5cf9-75bd-8c78-936e835477be.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring state-of-the-art cardio machines and strength training equipment. Step outside to the pool area for a refreshing dip.",
      "link": "",
      "alt_text": "Gym with treadmills, ellipticals, and weight machines. Doors lead to an outdoor pool area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f1ed538f-eae2-44ee-89a6-948f78f242cb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1a4d-fd6b-7589-be5d-8950c129ba7a.webp",
      "image_media": {
        "alt_text": "A modern and spacious community lounge with brown leather seating, small tables, a coffee bar, and large arched windows.",
        "public_id": "019f1a4d-fd6b-7589-be5d-8950c129ba7a",
        "storage_key": "property/5670511623274496/019f1a4d-fd6b-7589-be5d-8950c129ba7a.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax and socialize in our inviting community lounge, featuring comfortable seating, a convenient coffee bar, and bright natural light.",
      "link": "",
      "alt_text": "A modern and spacious community lounge with brown leather seating, small tables, a coffee bar, and large arched windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b8051cc5-d1c8-4933-a4de-ed011192c48b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1a4e-2ed4-7378-af26-8dfbca0dc7aa.webp",
      "image_media": {
        "alt_text": "Luxurious community lounge with comfortable seating and a billiards table.",
        "public_id": "019f1a4e-2ed4-7378-af26-8dfbca0dc7aa",
        "storage_key": "property/5670511623274496/019f1a4e-2ed4-7378-af26-8dfbca0dc7aa.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Unwind and socialize in our spacious community lounge, featuring plush seating, a billiards table, and elegant decor.",
      "link": "",
      "alt_text": "Luxurious community lounge with comfortable seating and a billiards table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b9843062-7c64-49bc-94c7-0f0c920201f9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1a4e-38c4-76cd-a69f-e60e283e9974.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with balconies and parking lot.",
        "public_id": "019f1a4e-38c4-76cd-a69f-e60e283e9974",
        "storage_key": "property/5670511623274496/019f1a4e-38c4-76cd-a69f-e60e283e9974.webp",
        "width": 2186,
        "height": 1456
      },
      "title": "Community",
      "description": "Beautifully maintained apartment building exterior, featuring private balconies and ample parking.",
      "link": "",
      "alt_text": "Exterior view of apartment building with balconies and parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_da2c92fd-8d87-4fb0-8c41-bc7e12cbc096",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1a4e-36c1-750e-b637-46c0d4e4c113.webp",
      "image_media": {
        "alt_text": "Outdoor patio area with lounge seating, a built-in grill, and a pool in the background.",
        "public_id": "019f1a4e-36c1-750e-b637-46c0d4e4c113",
        "storage_key": "property/5670511623274496/019f1a4e-36c1-750e-b637-46c0d4e4c113.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax and entertain in our beautifully appointed outdoor patio area, complete with comfortable lounge seating, a premium grill station, and a sparkling swimming pool.",
      "link": "",
      "alt_text": "Outdoor patio area with lounge seating, a built-in grill, and a pool in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_62ce2cf8-f15e-4a4f-b4e6-c686791b78ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1a4e-1a91-76fe-b085-92819f4e536f.webp",
      "image_media": {
        "alt_text": "Billiard table and pool cues in game room with pool view.",
        "public_id": "019f1a4e-1a91-76fe-b085-92819f4e536f",
        "storage_key": "property/5670511623274496/019f1a4e-1a91-76fe-b085-92819f4e536f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a game of billiards in our spacious game room, featuring a professional billiard table and cues, with a view of the sparkling outdoor pool.",
      "link": "",
      "alt_text": "Billiard table and pool cues in game room with pool view.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_54f107a7-b85b-4e5d-be36-d2e2a030bdd3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1a4d-fd6c-7025-97b2-45da3a84b09b.webp",
      "image_media": {
        "alt_text": "Resort-style outdoor swimming pool with lounge chairs and umbrellas",
        "public_id": "019f1a4d-fd6c-7025-97b2-45da3a84b09b",
        "storage_key": "property/5670511623274496/019f1a4d-fd6c-7025-97b2-45da3a84b09b.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and umbrellas. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Resort-style outdoor swimming pool with lounge chairs and umbrellas",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c10815d4-42c4-4dff-970c-318a0b9bcb93",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1a4e-1b08-7749-84b1-e898de665cf8.webp",
      "image_media": {
        "alt_text": "Stone fire pit with built-in stone benches and a surrounding concrete patio, set in a grassy courtyard with outdoor fitness equipment in the background.",
        "public_id": "019f1a4e-1b08-7749-84b1-e898de665cf8",
        "storage_key": "property/5670511623274496/019f1a4e-1b08-7749-84b1-e898de665cf8.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Gather around the charming stone fire pit and enjoy a cozy evening outdoors. This community amenity features comfortable stone seating and is perfect for socializing with neighbors.",
      "link": "",
      "alt_text": "Stone fire pit with built-in stone benches and a surrounding concrete patio, set in a grassy courtyard with outdoor fitness equipment in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_009ab7c7-88ea-4edf-be82-4db0141078bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1a4d-eda1-739d-b0e6-bd7f3a3c7002.webp",
      "image_media": {
        "alt_text": "Interior of a well-equipped fitness center with treadmills, weight machines, and large mirrors.",
        "public_id": "019f1a4d-eda1-739d-b0e6-bd7f3a3c7002",
        "storage_key": "property/5670511623274496/019f1a4d-eda1-739d-b0e6-bd7f3a3c7002.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a full range of cardio and weight training equipment to help you achieve your wellness goals.",
      "link": "",
      "alt_text": "Interior of a well-equipped fitness center with treadmills, weight machines, and large mirrors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_725752b5-997c-4d17-a3a0-d58226d63be5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1a4d-ec7c-7169-864e-150f298b3a35.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, adjacent to apartment buildings.",
        "public_id": "019f1a4d-ec7c-7169-864e-150f298b3a35",
        "storage_key": "property/5670511623274496/019f1a4d-ec7c-7169-864e-150f298b3a35.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim or relax by the pool in our resort-style oasis, complete with comfortable lounge chairs and shaded umbrellas.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, adjacent to apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_02763822-29d4-4cd7-a965-529235715018",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1a4d-fd9d-701f-bcf6-b59911483d0c.webp",
      "image_media": {
        "alt_text": "Outdoor patio area with built-in grill and seating.",
        "public_id": "019f1a4d-fd9d-701f-bcf6-b59911483d0c",
        "storage_key": "property/5670511623274496/019f1a4d-fd9d-701f-bcf6-b59911483d0c.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy outdoor living with this spacious patio, featuring a built-in grill and comfortable seating areas perfect for entertaining.",
      "link": "",
      "alt_text": "Outdoor patio area with built-in grill and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ec0a56d2-5a89-472f-93c0-35a4b2f280f6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1a4e-6340-7434-b198-e69900daabd9.webp",
      "image_media": {
        "alt_text": "Walk-in closet with white shelving and hanging rods, and a built-in drawer.",
        "public_id": "019f1a4e-6340-7434-b198-e69900daabd9",
        "storage_key": "property/5670511623274496/019f1a4e-6340-7434-b198-e69900daabd9.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample white shelving, built-in drawers, and multiple hanging rods for all your storage needs.",
      "link": "",
      "alt_text": "Walk-in closet with white shelving and hanging rods, and a built-in drawer.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9f99b591-c860-4ec6-8d82-d543e687c871",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1a4e-55ed-741f-a859-1f181aa07e2d.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a bathtub, toilet, and vanity with a granite countertop.",
        "public_id": "019f1a4e-55ed-741f-a859-1f181aa07e2d",
        "storage_key": "property/5670511623274496/019f1a4e-55ed-741f-a859-1f181aa07e2d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy the spacious and modern bathroom featuring a soaking tub, a sleek vanity with granite countertops, and ample storage. Perfect for unwinding after a long day.",
      "link": "",
      "alt_text": "Modern bathroom with a bathtub, toilet, and vanity with a granite countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d1874ab5-1198-42be-a569-0fe5efbbd6db",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1a4e-29fa-710d-8b5c-25d18703882e.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and bathtub.",
        "public_id": "019f1a4e-29fa-710d-8b5c-25d18703882e",
        "storage_key": "property/5670511623274496/019f1a4e-29fa-710d-8b5c-25d18703882e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed bathroom, featuring a spacious vanity with granite countertops, a large mirror, and a relaxing bathtub. This space offers both style and functionality for your daily routine.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, toilet, and bathtub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5ccd52c9-6475-4ee4-82b1-f616b83ddbf1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1a4e-78ca-72a7-9a92-9c52aaf4168e.webp",
      "image_media": {
        "alt_text": "Hallway with artwork and doors leading to rooms.",
        "public_id": "019f1a4e-78ca-72a7-9a92-9c52aaf4168e",
        "storage_key": "property/5670511623274496/019f1a4e-78ca-72a7-9a92-9c52aaf4168e.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Step into this inviting hallway, adorned with tasteful artwork and providing access to your private living spaces.",
      "link": "",
      "alt_text": "Hallway with artwork and doors leading to rooms.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1c12b7fd-fade-4595-9463-77bcdc7d3a07",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1a4e-4c48-73aa-b424-60b622317708.webp",
      "image_media": {
        "alt_text": "Modern dining area with a large table and chairs next to a marble island and kitchen.",
        "public_id": "019f1a4e-4c48-73aa-b424-60b622317708",
        "storage_key": "property/5670511623274496/019f1a4e-4c48-73aa-b424-60b622317708.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy a stylish dining experience in this modern space, featuring a large table with comfortable seating, a marble-topped island, and a fully equipped kitchen.",
      "link": "",
      "alt_text": "Modern dining area with a large table and chairs next to a marble island and kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5cf4c6cb-7dc2-40ac-b1e0-d9e414dffb04",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1a4e-39df-7450-8913-d4bddea263d0.webp",
      "image_media": {
        "alt_text": "In-unit washer and dryer next to a bathroom vanity.",
        "public_id": "019f1a4e-39df-7450-8913-d4bddea263d0",
        "storage_key": "property/5670511623274496/019f1a4e-39df-7450-8913-d4bddea263d0.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry facilities are provided adjacent to a well-appointed bathroom, featuring a granite-top vanity and ample storage.",
      "link": "",
      "alt_text": "In-unit washer and dryer next to a bathroom vanity.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3fc87da8-0253-4635-9c4e-be7e3da1f3f6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1a4e-3396-75a1-a15c-4fb86ed4dd2e.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, closet, and access to the bathroom.",
        "public_id": "019f1a4e-3396-75a1-a15c-4fb86ed4dd2e",
        "storage_key": "property/5670511623274496/019f1a4e-3396-75a1-a15c-4fb86ed4dd2e.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable queen-size bed with stylish bedding, a convenient nightstand, and a spacious walk-in closet. Access to the en-suite bathroom is also visible.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstand, closet, and access to the bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ec7cfd11-6003-4f46-b130-16980e12961e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1a4e-1eab-77ed-8632-d56baae21da6.webp",
      "image_media": {
        "alt_text": "Modern living room and kitchen area with light gray walls, a beige sofa, and a kitchen island.",
        "public_id": "019f1a4e-1eab-77ed-8632-d56baae21da6",
        "storage_key": "property/5670511623274496/019f1a4e-1eab-77ed-8632-d56baae21da6.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Spacious living room and kitchen featuring a comfortable sofa, stylish decor, and a fully equipped kitchen with modern appliances.",
      "link": "",
      "alt_text": "Modern living room and kitchen area with light gray walls, a beige sofa, and a kitchen island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_75ea5f26-2b03-4538-83fe-1734c4be1e31",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1a4d-fdc1-7179-97e7-db0caed98d02.webp",
      "image_media": {
        "alt_text": "Modern kitchen island with granite countertop and bar stools, flowing into a living room with sofa and coffee table.",
        "public_id": "019f1a4d-fdc1-7179-97e7-db0caed98d02",
        "storage_key": "property/5670511623274496/019f1a4d-fdc1-7179-97e7-db0caed98d02.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Experience the seamless flow between your kitchen and living area, perfect for entertaining or relaxing, in this beautifully appointed apartment.",
      "link": "",
      "alt_text": "Modern kitchen island with granite countertop and bar stools, flowing into a living room with sofa and coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b665e049-da32-4bab-b21c-2cf323685ed5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1a4e-1a05-7674-b7f4-5b0c27aef143.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, dresser, and accent chair.",
        "public_id": "019f1a4e-1a05-7674-b7f4-5b0c27aef143",
        "storage_key": "property/5670511623274496/019f1a4e-1a05-7674-b7f4-5b0c27aef143.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "A comfortable and stylish bedroom featuring a king-size bed with a wooden headboard, a cozy accent chair, and a dresser. Perfect for relaxation.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, dresser, and accent chair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9dff95e2-9628-45dd-b77d-73914a57b240",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1a4e-15d3-728f-83b8-66d928d755e8.webp",
      "image_media": {
        "alt_text": "Dining area with a table and chairs, leading into a kitchen with white cabinets.",
        "public_id": "019f1a4e-15d3-728f-83b8-66d928d755e8",
        "storage_key": "property/5670511623274496/019f1a4e-15d3-728f-83b8-66d928d755e8.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "A spacious dining area with a modern table and chairs opens into a well-appointed kitchen featuring ample counter space and white cabinetry. Perfect for entertaining and everyday living.",
      "link": "",
      "alt_text": "Dining area with a table and chairs, leading into a kitchen with white cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b946edd2-e5bc-49aa-b990-62e549cb307a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1a4d-f81d-708a-9d78-625a47fc75b3.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-sized bed, artwork, and a walk-in closet.",
        "public_id": "019f1a4d-f81d-708a-9d78-625a47fc75b3",
        "storage_key": "property/5670511623274496/019f1a4d-f81d-708a-9d78-625a47fc75b3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Discover comfort and style in our spacious bedrooms, featuring modern furnishings and ample closet space for a relaxed living experience.",
      "link": "",
      "alt_text": "Bedroom with a king-sized bed, artwork, and a walk-in closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6c504465-23e3-4e72-a2d3-83079b46d26a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1a4d-ec18-717e-8565-712a1745ab55.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a deep sink.",
        "public_id": "019f1a4d-ec18-717e-8565-712a1745ab55",
        "storage_key": "property/5670511623274496/019f1a4d-ec18-717e-8565-712a1745ab55.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Explore the stylish and functional kitchen featuring sleek white cabinetry, elegant granite countertops, and modern stainless steel appliances, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a deep sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0195909c-c4e1-4c66-8a70-df439a659a84",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1a4d-ec7d-733b-833e-10b6c81b61ae.webp",
      "image_media": {
        "alt_text": "Stylish living room with a sofa, coffee table, armchair, and bar cart.",
        "public_id": "019f1a4d-ec7d-733b-833e-10b6c81b61ae",
        "storage_key": "property/5670511623274496/019f1a4d-ec7d-733b-833e-10b6c81b61ae.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed living room, perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Stylish living room with a sofa, coffee table, armchair, and bar cart.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5d6ab4c3-48e5-4da3-a90f-73dc8b4e755e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1a4d-fd96-76e8-9d73-45f5058f013c.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a deep sink.",
        "public_id": "019f1a4d-fd96-76e8-9d73-45f5058f013c",
        "storage_key": "property/5670511623274496/019f1a4d-fd96-76e8-9d73-45f5058f013c.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring sleek white cabinetry, sparkling granite countertops, and modern stainless steel appliances. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a deep sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_213dde77-aaa1-457a-b335-df6a28cafc4e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019df5d3-6af6-71f8-b688-7b51d804c909.webp",
      "image_media": {
        "alt_text": "Artistry logo",
        "public_id": "019df5d3-6af6-71f8-b688-7b51d804c909",
        "storage_key": "property/5670511623274496/019df5d3-6af6-71f8-b688-7b51d804c909.webp",
        "width": 1002,
        "height": 1001
      },
      "title": "Logo",
      "description": "The Artistry logo features a stylized orange wordmark on a black background.",
      "link": "",
      "alt_text": "Artistry logo",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4365ec7a-786a-4c0f-836f-d0d2cf2cd648",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019df5d3-6b3c-70af-9931-4b43ad4867b3.webp",
      "image_media": {
        "alt_text": "Artistry at Bethesda Park logo",
        "public_id": "019df5d3-6b3c-70af-9931-4b43ad4867b3",
        "storage_key": "property/5670511623274496/019df5d3-6b3c-70af-9931-4b43ad4867b3.webp",
        "width": 741,
        "height": 516
      },
      "title": "Logo",
      "description": "The logo for Artistry at Bethesda Park, featuring the name in a stylized orange script font.",
      "link": "",
      "alt_text": "Artistry at Bethesda Park logo",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ae5eca46-3054-4a34-8619-1099bf9674ef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019df5d3-6af8-70a9-aa63-29a7770683ec.webp",
      "image_media": {
        "alt_text": "Artistry at Bethesda Park logo",
        "public_id": "019df5d3-6af8-70a9-aa63-29a7770683ec",
        "storage_key": "property/5670511623274496/019df5d3-6af8-70a9-aa63-29a7770683ec.webp",
        "width": 399,
        "height": 384
      },
      "title": "Logo",
      "description": "The logo for Artistry at Bethesda Park, featuring stylized white text on a gray background.",
      "link": "",
      "alt_text": "Artistry at Bethesda Park logo",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_282abfc7-896d-4118-86a2-bbed927e90dd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019df5d3-6ae0-7008-9159-96d16b3eb65c.webp",
      "image_media": {
        "alt_text": "Artistry at Bethesda Park logo",
        "public_id": "019df5d3-6ae0-7008-9159-96d16b3eb65c",
        "storage_key": "property/5670511623274496/019df5d3-6ae0-7008-9159-96d16b3eb65c.webp",
        "width": 371,
        "height": 257
      },
      "title": "Logo",
      "description": "Artistry at Bethesda Park logo",
      "link": "",
      "alt_text": "Artistry at Bethesda Park logo",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_f178a1acfabf789d9e861398",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "The Catfe",
      "poi_type": "Restaurants",
      "poi_address": "426 Bethesda School Rd, Lawrenceville, GA 30044, USA",
      "poi_short_description": "Laid-back cafe serving sandwiches, pies, and coffee in the company of cats.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-216d-7398-9461-48fecaf7a0df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-216d-7398-9461-48fecaf7a0df",
        "storage_key": "property/5670511623274496/019f1515-216d-7398-9461-48fecaf7a0df.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://thecatfeco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16388805791061250041&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-catfe",
      "poi_latitude": "33.9228641",
      "poi_longitude": "-84.083838",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 770-206-0971",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-a864-77fe-b947-08d15c34b0ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-a864-77fe-b947-08d15c34b0ae",
        "storage_key": "property/5670511623274496/019f1515-a864-77fe-b947-08d15c34b0ae.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJF7LVM3u99YgR-Q8SDQm8cOM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "ec_b0981fcacf318f0f77f70630",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Mei Garden",
      "poi_type": "Restaurants",
      "poi_address": "3059 Lawrenceville Hwy Ste K, Lawrenceville, GA 30044, USA",
      "poi_short_description": "Casual restaurant offering a selection of Chinese fare including egg rolls and shrimp with broccoli.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-2365-7272-8a14-bf98a51ce3b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-2365-7272-8a14-bf98a51ce3b0",
        "storage_key": "property/5670511623274496/019f1515-2365-7272-8a14-bf98a51ce3b0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.meigarden-ga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18045927402201223455&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mei-garden",
      "poi_latitude": "33.9224353",
      "poi_longitude": "-84.0849745",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 770-925-7333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca6e-77f9-bdee-c480d26855b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca6e-77f9-bdee-c480d26855b3",
        "storage_key": "property/5670511623274496/019f1512-ca6e-77f9-bdee-c480d26855b3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7T09eti79YgRHxGxYlwDcPo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "ec_d23668e5b5a7d033ec5d1701",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Monterrey Restaurante Mexicano",
      "poi_type": "Restaurants",
      "poi_address": "1848 Old Norcross Rd Ste 1200, Lawrenceville, GA 30044, USA",
      "poi_short_description": "Unassuming space providing a range of familiar Mexican grub, plus margaritas & a full bar.",
      "poi_long_description": "Unassuming space providing a range of familiar Mexican grub, plus margaritas & a full bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-2302-7066-9167-565e8e920880.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-2302-7066-9167-565e8e920880",
        "storage_key": "property/5670511623274496/019f1515-2302-7066-9167-565e8e920880.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://monterreyrestaurantemexicano.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=7316944370807313220&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "monterrey-restaurante-mexicano",
      "poi_latitude": "33.9521408",
      "poi_longitude": "-84.0567932",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 770-237-2511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca6e-77f9-bdee-c480d26855b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca6e-77f9-bdee-c480d26855b3",
        "storage_key": "property/5670511623274496/019f1512-ca6e-77f9-bdee-c480d26855b3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxQ1Lv1m89YgRRJNDbyMCi2U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_783106e364d7119e37aeb677",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Mi Bella Colombia",
      "poi_type": "Restaurants",
      "poi_address": "2785 Cruse Rd NW #2, Lawrenceville, GA 30044, USA",
      "poi_short_description": "Colombian restaurant offering comfort food and small plates in a casual environment.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-2ec2-70f0-8876-99a7f3dacdcc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-2ec2-70f0-8876-99a7f3dacdcc",
        "storage_key": "property/5670511623274496/019f1515-2ec2-70f0-8876-99a7f3dacdcc.webp",
        "width": 1280,
        "height": 606
      },
      "poi_business_url": "https://mibellacolombiaga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3701414989645472894&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mi-bella-colombia",
      "poi_latitude": "33.9373299",
      "poi_longitude": "-84.0881686",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 470-592-8930",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca6e-77f9-bdee-c480d26855b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca6e-77f9-bdee-c480d26855b3",
        "storage_key": "property/5670511623274496/019f1512-ca6e-77f9-bdee-c480d26855b3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLy6k7Lu89YgRfuQfeFIRXjM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "colombian_restaurant"
    },
    {
      "id": "ec_58a17256a3385277738a2cf1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Anejo",
      "poi_type": "Restaurants",
      "poi_address": "165 N Perry St Ste 200, Lawrenceville, GA 30046, USA",
      "poi_short_description": "Spicy and Skinny margaritas and tasty tacos are served at this casual Mexican eatery featuring a rooftop.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-1d96-757b-99bf-2491f31e75e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-1d96-757b-99bf-2491f31e75e0",
        "storage_key": "property/5670511623274496/019f1515-1d96-757b-99bf-2491f31e75e0.webp",
        "width": 990,
        "height": 761
      },
      "poi_business_url": "https://www.anejodtl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12154699657962299631&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anejo",
      "poi_latitude": "33.956828",
      "poi_longitude": "-83.989948",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 470-282-1501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca6e-77f9-bdee-c480d26855b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca6e-77f9-bdee-c480d26855b3",
        "storage_key": "property/5670511623274496/019f1512-ca6e-77f9-bdee-c480d26855b3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ10Aj5BS_9YgR76BnyPAqrqg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_7134993e6d95e4bc7e5ea8a2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Rustico Mexican Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "851 Oak Rd SW #5, Lawrenceville, GA 30044, USA",
      "poi_short_description": "Casual restaurant known for its steaks and tacos in addition to traditional south-of-the-border dishes like fajitas.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-2618-73cc-94ea-8988a0dea82d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-2618-73cc-94ea-8988a0dea82d",
        "storage_key": "property/5670511623274496/019f1515-2618-73cc-94ea-8988a0dea82d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.rusticomexicancuisine.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=675694295232850507&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rustico-mexican-cuisine",
      "poi_latitude": "33.8878687",
      "poi_longitude": "-84.0627094",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 770-609-8094",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca6e-77f9-bdee-c480d26855b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca6e-77f9-bdee-c480d26855b3",
        "storage_key": "property/5670511623274496/019f1512-ca6e-77f9-bdee-c480d26855b3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdckPoNy79YgRS6ocrGGMYAk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_233bd6566591a42af4658c73",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Real Olive",
      "poi_type": "Restaurants",
      "poi_address": "755 Lawrenceville-Suwanee Rd #1710, Lawrenceville, GA 30043, USA",
      "poi_short_description": "Warm, casual option with some outdoor tables, many vegetarian options & lunch specials.",
      "poi_long_description": "Warm, casual option with some outdoor tables, many vegetarian options & lunch specials.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-1de4-726b-b1af-a41b47d5bc5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-1de4-726b-b1af-a41b47d5bc5b",
        "storage_key": "property/5670511623274496/019f1515-1de4-726b-b1af-a41b47d5bc5b.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "https://olivemgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13964089206763819447&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "real-olive",
      "poi_latitude": "33.9661976",
      "poi_longitude": "-84.02299119999999",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 770-513-9555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca6e-77f9-bdee-c480d26855b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca6e-77f9-bdee-c480d26855b3",
        "storage_key": "property/5670511623274496/019f1512-ca6e-77f9-bdee-c480d26855b3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7weHeNO99YgRtxEGDSZpysE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "ec_16634e4509a3e47498b75e29",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Taiyo Ramen & Sushi",
      "poi_type": "Restaurants",
      "poi_address": "755 Lawrenceville-Suwanee Rd Ste 1530, Lawrenceville, GA 30043, USA",
      "poi_short_description": "Clean, laid-back eatery serving fresh, flavorful sushi and ramen.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-1ea2-759b-8a83-9b830c897023.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-1ea2-759b-8a83-9b830c897023",
        "storage_key": "property/5670511623274496/019f1515-1ea2-759b-8a83-9b830c897023.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.taiyoramensushi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17609486720581090011&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taiyo-ramen--sushi",
      "poi_latitude": "33.9660115",
      "poi_longitude": "-84.02264939999999",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 678-878-3217",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca6e-77f9-bdee-c480d26855b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca6e-77f9-bdee-c480d26855b3",
        "storage_key": "property/5670511623274496/019f1512-ca6e-77f9-bdee-c480d26855b3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJI9sTfUy99YgR27oxkd92YfQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "ec_218079b002ec26d61c1d691f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Magazzino Delle Pizza",
      "poi_type": "Restaurants",
      "poi_address": "137 S Perry St, Lawrenceville, GA 30046, USA",
      "poi_short_description": "Casual pizzeria offering wood-fired pies, empanadas, and salads, plus gelato.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-2e6c-7776-b872-25a36b17ab9b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-2e6c-7776-b872-25a36b17ab9b",
        "storage_key": "property/5670511623274496/019f1515-2e6c-7776-b872-25a36b17ab9b.webp",
        "width": 959,
        "height": 1280
      },
      "poi_business_url": "https://www.magazzinodellepizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15463706095057435990&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "magazzino-delle-pizza",
      "poi_latitude": "33.955683",
      "poi_longitude": "-83.9893225",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 470-484-1917",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca6e-77f9-bdee-c480d26855b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca6e-77f9-bdee-c480d26855b3",
        "storage_key": "property/5670511623274496/019f1512-ca6e-77f9-bdee-c480d26855b3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPRgYDji_9YgRVv3wYsMemtY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_5f2579839e84190636dbcc70",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Dominick's",
      "poi_type": "Restaurants",
      "poi_address": "197 W Crogan St, Lawrenceville, GA 30046, USA",
      "poi_short_description": "Bustling Italian chain serving lunchtime sandwiches & a full dinner menu of classic dishes.",
      "poi_long_description": "Bustling Italian chain serving lunchtime sandwiches & a full dinner menu of classic dishes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-1d84-77e8-a906-568c084ac329.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-1d84-77e8-a906-568c084ac329",
        "storage_key": "property/5670511623274496/019f1515-1d84-77e8-a906-568c084ac329.webp",
        "width": 348,
        "height": 348
      },
      "poi_business_url": "http://www.dominickslawrenceville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11482018174269915447&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dominicks",
      "poi_latitude": "33.9561335",
      "poi_longitude": "-83.98944139999999",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 770-277-8477",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca6e-77f9-bdee-c480d26855b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca6e-77f9-bdee-c480d26855b3",
        "storage_key": "property/5670511623274496/019f1512-ca6e-77f9-bdee-c480d26855b3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6QKO_fO-9YgRNwHw9bFSWJ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_a46773ec0b182a50ca46c4ef",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Perry St. Chophouse",
      "poi_type": "Restaurants",
      "poi_address": "125 N Perry St, Lawrenceville, GA 30046, USA",
      "poi_short_description": "Elegant steakhouse featuring classic entrees and an oyster bar for brunch, lunch and dinner.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-280f-7065-80e5-048de7d63a96.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-280f-7065-80e5-048de7d63a96",
        "storage_key": "property/5670511623274496/019f1515-280f-7065-80e5-048de7d63a96.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.perrystreetchophouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1670780936732173478&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "perry-st-chophouse",
      "poi_latitude": "33.9565177",
      "poi_longitude": "-83.9898436",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 770-854-0901",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca6e-77f9-bdee-c480d26855b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca6e-77f9-bdee-c480d26855b3",
        "storage_key": "property/5670511623274496/019f1512-ca6e-77f9-bdee-c480d26855b3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJb2jDepi_9YgRpmRq52jOLxc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "ec_73525b11c97d4a14dda723b0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Village Burger",
      "poi_type": "Restaurants",
      "poi_address": "137 S Perry St Ste B, Lawrenceville, GA 30046, USA",
      "poi_short_description": "Casual burger joint turning out crispy chicken wings and hot dogs, plus fries and milkshakes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-2b31-72ae-8cb9-9f9e27f0102c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-2b31-72ae-8cb9-9f9e27f0102c",
        "storage_key": "property/5670511623274496/019f1515-2b31-72ae-8cb9-9f9e27f0102c.webp",
        "width": 595,
        "height": 446
      },
      "poi_business_url": "https://villageburger.com/dunwoody-village-burger-dunwoody-locations-lawrenceville",
      "poi_directions_map_url": "https://maps.google.com/?cid=781519041303554491&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "village-burger",
      "poi_latitude": "33.955609",
      "poi_longitude": "-83.9893483",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 678-373-1223",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca6e-77f9-bdee-c480d26855b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca6e-77f9-bdee-c480d26855b3",
        "storage_key": "property/5670511623274496/019f1512-ca6e-77f9-bdee-c480d26855b3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJsazd0My_9YgRuykaam2D2Ao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_cecd3b6d3af33f1fd507445e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Break Coffee Roasters",
      "poi_type": "Restaurants",
      "poi_address": "235 N Perry St, Lawrenceville, GA 30046, USA",
      "poi_short_description": "Bright, casual, local coffee shop for pastries alongside its own roasted beans.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-2ad9-742c-be2f-a31ffdeaba26.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-2ad9-742c-be2f-a31ffdeaba26",
        "storage_key": "property/5670511623274496/019f1515-2ad9-742c-be2f-a31ffdeaba26.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://breakroasters.com/pages/lawrenceville",
      "poi_directions_map_url": "https://maps.google.com/?cid=12142828233077538959&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "break-coffee-roasters",
      "poi_latitude": "33.9577728",
      "poi_longitude": "-83.98989019999999",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 678-824-5268",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-a864-77fe-b947-08d15c34b0ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-a864-77fe-b947-08d15c34b0ae",
        "storage_key": "property/5670511623274496/019f1515-a864-77fe-b947-08d15c34b0ae.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJdWPLtDa_9YgRj8ArSfH9g6g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_1af167530e5e1a7920d40786",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Reyna's Espresso & Sweets",
      "poi_type": "Restaurants",
      "poi_address": "137 W Crogan St, Lawrenceville, GA 30046, USA",
      "poi_short_description": "Relaxed coffee spot roasting its own beans on-site, along with pastries and hearty breakfast bites.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-39b6-77f9-9fa2-a2c9745c1c29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-39b6-77f9-9fa2-a2c9745c1c29",
        "storage_key": "property/5670511623274496/019f1515-39b6-77f9-9fa2-a2c9745c1c29.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://reynas.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18233837215552986798&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "reynas-espresso--sweets",
      "poi_latitude": "33.9561553",
      "poi_longitude": "-83.988828",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 470-294-1631",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-a864-77fe-b947-08d15c34b0ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-a864-77fe-b947-08d15c34b0ae",
        "storage_key": "property/5670511623274496/019f1515-a864-77fe-b947-08d15c34b0ae.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJyXHtp5-_9YgRrl5VLVeaC_0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_846520bb4bdbd9cac465dd66",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Tea Lam's Corner",
      "poi_type": "Restaurants",
      "poi_address": "Across from DT, Lawrenceville Parking Deck, 162 E Crogan St, Lawrenceville, GA 30046, USA",
      "poi_short_description": "Laid-back eatery serving Vietnamese noodles, sandwiches, and desserts in a casual setting.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-3504-7064-9b57-7426c5967220.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-3504-7064-9b57-7426c5967220",
        "storage_key": "property/5670511623274496/019f1515-3504-7064-9b57-7426c5967220.webp",
        "width": 963,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5453528459238691885&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tea-lams-corner",
      "poi_latitude": "33.956277",
      "poi_longitude": "-83.9877997",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 678-353-6111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca6e-77f9-bdee-c480d26855b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca6e-77f9-bdee-c480d26855b3",
        "storage_key": "property/5670511623274496/019f1512-ca6e-77f9-bdee-c480d26855b3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUzByaBu_9YgRLdRnWT3Trks",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vietnamese_restaurant"
    },
    {
      "id": "ec_d569568ea8667c6b032ab97e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "1400 Lawrenceville Hwy, Lawrenceville, GA 30044, USA",
      "poi_short_description": "Chain department store offering apparel, electronics, groceries, toys, and household goods, plus a pharmacy.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-3acf-71c8-b439-1c0ce531cd88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-3acf-71c8-b439-1c0ce531cd88",
        "storage_key": "property/5670511623274496/019f1515-3acf-71c8-b439-1c0ce531cd88.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/3388-lawrenceville-ga/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=2884423111979722136&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "33.9364832",
      "poi_longitude": "-84.0250038",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 770-682-1992",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca61-714b-8496-8f509ad15d4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca61-714b-8496-8f509ad15d4e",
        "storage_key": "property/5670511623274496/019f1512-ca61-714b-8496-8f509ad15d4e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJDagDbhe89YgRmGV6u4mHByg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_c6a1b4e3ecb20e91bf061b7c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Publix Super Market at Village Shoppes of Sugarloaf",
      "poi_type": "Shopping & Retail",
      "poi_address": "3370 Sugarloaf Pkwy, Lawrenceville, GA 30044, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-3bed-716a-b68a-3bde0a8035a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-3bed-716a-b68a-3bde0a8035a1",
        "storage_key": "property/5670511623274496/019f1515-3bed-716a-b68a-3bde0a8035a1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=859&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=2199475639768893398&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-village-shoppes-of-sugarloaf",
      "poi_latitude": "33.9211548",
      "poi_longitude": "-84.01819119999999",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 678-376-3844",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca91-7348-9ca4-328dfdbfa2c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca91-7348-9ca4-328dfdbfa2c0",
        "storage_key": "property/5670511623274496/019f1512-ca91-7348-9ca4-328dfdbfa2c0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH27Qlqq-9YgR1seM6HAbhh4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_75bdc2499508510d55c65bb2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "455 Grayson Hwy, Lawrenceville, GA 30046, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-373e-7006-803a-bc93f10228ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-373e-7006-803a-bc93f10228ac",
        "storage_key": "property/5670511623274496/019f1515-373e-7006-803a-bc93f10228ac.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/ga/lawrenceville/lawrenceville-town-center/011/00352?cid=loc_01100352_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=5278467043425110491&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "33.9386385",
      "poi_longitude": "-83.982592",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 770-962-1063",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca91-7348-9ca4-328dfdbfa2c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca91-7348-9ca4-328dfdbfa2c0",
        "storage_key": "property/5670511623274496/019f1512-ca91-7348-9ca4-328dfdbfa2c0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLcwWiN2-9YgR28n1Oc_hQEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_7189cf46ad578556b5ef0d6e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "1225 Scenic Hwy N, Lawrenceville, GA 30045, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-3f38-704f-8471-10d807d83dd0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-3f38-704f-8471-10d807d83dd0",
        "storage_key": "property/5670511623274496/019f1515-3f38-704f-8471-10d807d83dd0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ga/lawrenceville/1225-scenic-highway/l942",
      "poi_directions_map_url": "https://maps.google.com/?cid=1089909220989406569&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "33.901458",
      "poi_longitude": "-84.005697",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca91-7348-9ca4-328dfdbfa2c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca91-7348-9ca4-328dfdbfa2c0",
        "storage_key": "property/5670511623274496/019f1512-ca91-7348-9ca4-328dfdbfa2c0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmbqa5ES59YgRaQ1_cqkiIA8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_0b4185e2e7fcb976df9a14d8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1250 Scenic Hwy S Ste 1704, Lawrenceville, GA 30045, USA",
      "poi_short_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_long_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-404b-7511-b6d3-012b91715679.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-404b-7511-b6d3-012b91715679",
        "storage_key": "property/5670511623274496/019f1515-404b-7511-b6d3-012b91715679.webp",
        "width": 1280,
        "height": 920
      },
      "poi_business_url": "https://sprouts.com/store/ga/lawrenceville/snellville",
      "poi_directions_map_url": "https://maps.google.com/?cid=11567119829477654178&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "33.9005343",
      "poi_longitude": "-84.00392599999999",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 678-690-1279",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca91-7348-9ca4-328dfdbfa2c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca91-7348-9ca4-328dfdbfa2c0",
        "storage_key": "property/5670511623274496/019f1512-ca91-7348-9ca4-328dfdbfa2c0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXYPZG0O59YgRon5kHjOqhqA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_04dd66758893744cc2eed2d8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Talpa Supermarkets - Lawrenceville",
      "poi_type": "Shopping & Retail",
      "poi_address": "2830 Club Dr, Lawrenceville, GA 30044, USA",
      "poi_short_description": "Familiar supermarket stocked with Mexican foods and supplies as well as fresh produce, meats, and bakery items.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-3fdc-7349-8b18-98f468cf77e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-3fdc-7349-8b18-98f468cf77e5",
        "storage_key": "property/5670511623274496/019f1515-3fdc-7349-8b18-98f468cf77e5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.supermercadostalpa.com/en/supermercados/5-talpa-4",
      "poi_directions_map_url": "https://maps.google.com/?cid=3098436625562361528&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "talpa-supermarkets---lawrenceville",
      "poi_latitude": "33.9366159",
      "poi_longitude": "-84.0897719",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 770-806-0707",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca91-7348-9ca4-328dfdbfa2c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca91-7348-9ca4-328dfdbfa2c0",
        "storage_key": "property/5670511623274496/019f1512-ca91-7348-9ca4-328dfdbfa2c0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_zugZLq89YgRuF602bHb_yo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_d7079f128551c1ab34b82db2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "1556 Lawrenceville Hwy, Lawrenceville, GA 30044, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-4bad-71ae-99f5-39cbe1aa94a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-4bad-71ae-99f5-39cbe1aa94a3",
        "storage_key": "property/5670511623274496/019f1515-4bad-71ae-99f5-39cbe1aa94a3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1556+lawrenceville+hwy-lawrenceville-ga-30044/id=5896",
      "poi_directions_map_url": "https://maps.google.com/?cid=13193236000031616543&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "33.9375566",
      "poi_longitude": "-84.03399739999999",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-962-4946",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca6d-762d-b4f9-1dba867fa9a9",
        "storage_key": "property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCfyebBS89YgRH67Hwz3KF7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_cd35cb21341132915df15f10",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "2650 Cruse Rd NW, Lawrenceville, GA 30044, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-430f-7218-847b-38ee6250cb12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-430f-7218-847b-38ee6250cb12",
        "storage_key": "property/5670511623274496/019f1515-430f-7218-847b-38ee6250cb12.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/lawrenceville-ga-pharmacies/2650-cruse-road-lawrenceville-ga-30044/storeid=2570?WT.mc_id=LS_GOOGLE_RX_2570",
      "poi_directions_map_url": "https://maps.google.com/?cid=13284165219801309726&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "33.9393659",
      "poi_longitude": "-84.0817644",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 770-921-8514",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-a86c-719c-8af4-4342f36bb081.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-a86c-719c-8af4-4342f36bb081",
        "storage_key": "property/5670511623274496/019f1515-a86c-719c-8af4-4342f36bb081.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF2LEc7689YgRHiLbh-LVWrg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_7d00b36e06cd03b3de936f66",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Sunoco",
      "poi_type": "Shopping & Retail",
      "poi_address": "2490 Cruse Rd NW, Lawrenceville, GA 30044, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-46d5-71d0-92cb-fad20bf323f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-46d5-71d0-92cb-fad20bf323f2",
        "storage_key": "property/5670511623274496/019f1515-46d5-71d0-92cb-fad20bf323f2.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://www.sunoco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14232613396276183018&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunoco",
      "poi_latitude": "33.9422263",
      "poi_longitude": "-84.07679929999999",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-962-7375",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-a86f-77de-a52a-60d22d7c67f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-a86f-77de-a52a-60d22d7c67f2",
        "storage_key": "property/5670511623274496/019f1515-a86f-77de-a52a-60d22d7c67f2.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJzZAw8JS89YgR6v-B7nlmhMU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "ec_3c5907f8ab865101bb07d2fb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Sugarloaf Mills",
      "poi_type": "Shopping & Retail",
      "poi_address": "5900 Sugarloaf Pkwy, Lawrenceville, GA 30043, USA",
      "poi_short_description": "Large indoor shopping mall features familiar chain retailers, dozens of eateries & a movie theater.",
      "poi_long_description": "Large indoor shopping mall features familiar chain retailers, dozens of eateries & a movie theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-8f99-70de-946b-1b6ae11e07f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-8f99-70de-946b-1b6ae11e07f1",
        "storage_key": "property/5670511623274496/019f1512-8f99-70de-946b-1b6ae11e07f1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.simon.com/mall/sugarloaf-mills",
      "poi_directions_map_url": "https://maps.google.com/?cid=14621995137507182859&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sugarloaf-mills",
      "poi_latitude": "33.9806714",
      "poi_longitude": "-84.0809653",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 470-665-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca61-714b-8496-8f509ad15d4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca61-714b-8496-8f509ad15d4e",
        "storage_key": "property/5670511623274496/019f1512-ca61-714b-8496-8f509ad15d4e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJvffBmj299YgRC8maXhvD68o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_d4c948633abc71a1fe1b5082",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Bethesda Elementary School",
      "poi_type": "Education",
      "poi_address": "525 Bethesda School Rd, Lawrenceville, GA 30044, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9156093984819030968&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bethesda-elementary-school",
      "poi_latitude": "33.9255054",
      "poi_longitude": "-84.0859203",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 770-921-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-a8a2-73da-b9ec-cea2c1614ed3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-a8a2-73da-b9ec-cea2c1614ed3",
        "storage_key": "property/5670511623274496/019f1515-a8a2-73da-b9ec-cea2c1614ed3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJy4Gh2Ka89YgRuKs61_f6EH8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_e04ae516b265d8fc4e6acb36",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Gwin Oaks Elementary School",
      "poi_type": "Education",
      "poi_address": "400 Gwin Oaks Dr, Lawrenceville, GA 30044, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-505d-7725-bb40-b5cf2081ba1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-505d-7725-bb40-b5cf2081ba1a",
        "storage_key": "property/5670511623274496/019f1515-505d-7725-bb40-b5cf2081ba1a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://gwinoakses.gcpsk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10005706535999417047&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gwin-oaks-elementary-school",
      "poi_latitude": "33.89559",
      "poi_longitude": "-84.0740463",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 770-972-3110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-a8a2-73da-b9ec-cea2c1614ed3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-a8a2-73da-b9ec-cea2c1614ed3",
        "storage_key": "property/5670511623274496/019f1515-a8a2-73da-b9ec-cea2c1614ed3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnR5X6g279YgR16oM_RRp24o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_1cc5c869b7d6522012aa9639",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Alford Elementary School",
      "poi_type": "Education",
      "poi_address": "2625 Lawrenceville Hwy, Lawrenceville, GA 30044, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-6127-74a6-8ac2-7d65b7258a67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-6127-74a6-8ac2-7d65b7258a67",
        "storage_key": "property/5670511623274496/019f1515-6127-74a6-8ac2-7d65b7258a67.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.alfordes.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4948852979839609871&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alford-elementary-school",
      "poi_latitude": "33.9253567",
      "poi_longitude": "-84.0708863",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 678-924-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-a8a2-73da-b9ec-cea2c1614ed3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-a8a2-73da-b9ec-cea2c1614ed3",
        "storage_key": "property/5670511623274496/019f1515-a8a2-73da-b9ec-cea2c1614ed3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ86XUt5y89YgRDyz5pJDbrUQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_15d03370aa4ff30ea5f3a633",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Richards Middle School",
      "poi_type": "Education",
      "poi_address": "3555 Sugarloaf Pkwy, Lawrenceville, GA 30044, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://schools.gcpsk12.org/RichardsMS",
      "poi_directions_map_url": "https://maps.google.com/?cid=2566016706524419853&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "richards-middle-school",
      "poi_latitude": "33.9277426",
      "poi_longitude": "-84.0202123",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 770-995-7133",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-a8a2-73da-b9ec-cea2c1614ed3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-a8a2-73da-b9ec-cea2c1614ed3",
        "storage_key": "property/5670511623274496/019f1515-a8a2-73da-b9ec-cea2c1614ed3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJXcEHdwO89YgRDRcbaJlSnCM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_cb9413575d319907d0312301",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Discovery High School",
      "poi_type": "Education",
      "poi_address": "1335 Old Norcross Rd, Lawrenceville, GA 30046, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-5379-717e-a2b6-fbc21077857b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-5379-717e-a2b6-fbc21077857b",
        "storage_key": "property/5670511623274496/019f1515-5379-717e-a2b6-fbc21077857b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.discoveryhighschool.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7767956700085304046&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "discovery-high-school",
      "poi_latitude": "33.9553149",
      "poi_longitude": "-84.034843",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 678-226-4250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-a8a2-73da-b9ec-cea2c1614ed3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-a8a2-73da-b9ec-cea2c1614ed3",
        "storage_key": "property/5670511623274496/019f1515-a8a2-73da-b9ec-cea2c1614ed3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkd9WDze89YgR7jozW3ZTzWs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_6a66b38854311cb11dcb841f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Gwinnett School of Mathematics, Science, and Technology",
      "poi_type": "Education",
      "poi_address": "970 McElvaney Ln NW, Lawrenceville, GA 30044, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-61f5-715c-9a9c-57a919dc4ce8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-61f5-715c-9a9c-57a919dc4ce8",
        "storage_key": "property/5670511623274496/019f1515-61f5-715c-9a9c-57a919dc4ce8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gcpsk12.org/gsmst",
      "poi_directions_map_url": "https://maps.google.com/?cid=7378895056990488125&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gwinnett-school-of-mathematics-science-and-technology",
      "poi_latitude": "33.952898",
      "poi_longitude": "-84.06015289999999",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 678-518-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-a8a2-73da-b9ec-cea2c1614ed3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-a8a2-73da-b9ec-cea2c1614ed3",
        "storage_key": "property/5670511623274496/019f1515-a8a2-73da-b9ec-cea2c1614ed3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGw4dxfe89YgRPcbNkvUZZ2Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_9df82476b57758703ebbe1c4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Georgia Gwinnett College",
      "poi_type": "Education",
      "poi_address": "1000 University Center Ln, Lawrenceville, GA 30043, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-581c-739d-8175-9903561ddafd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-581c-739d-8175-9903561ddafd",
        "storage_key": "property/5670511623274496/019f1515-581c-739d-8175-9903561ddafd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ggc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17256186828481170101&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgia-gwinnett-college",
      "poi_latitude": "33.9802966",
      "poi_longitude": "-84.0047709",
      "poi_miles_from_property": "9.0 mi",
      "poi_walking_minutes": "3 hours 23 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 678-407-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-a8a2-73da-b9ec-cea2c1614ed3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-a8a2-73da-b9ec-cea2c1614ed3",
        "storage_key": "property/5670511623274496/019f1515-a8a2-73da-b9ec-cea2c1614ed3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQyGfL2y-9YgRtQplSX5Keu8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_57805654bc3aeeb210d263f1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Chroma Early Learning Academy of Lawrenceville",
      "poi_type": "Education",
      "poi_address": "3650 Club Dr, Lawrenceville, GA 30044, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-5246-71e8-8151-a9b090e7b999.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-5246-71e8-8151-a9b090e7b999",
        "storage_key": "property/5670511623274496/019f1515-5246-71e8-8151-a9b090e7b999.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://chromaela.com/locations/lawrenceville-campus/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10841439119319928306&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chroma-early-learning-academy-of-lawrenceville",
      "poi_latitude": "33.9410553",
      "poi_longitude": "-84.12470900000001",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 470-570-1633",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-a8a2-73da-b9ec-cea2c1614ed3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-a8a2-73da-b9ec-cea2c1614ed3",
        "storage_key": "property/5670511623274496/019f1515-a8a2-73da-b9ec-cea2c1614ed3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJORsL2Zej9YgR8o0WSXCHdJY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_a33262cc64c5c11d4dcec922",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Herrington Academy",
      "poi_type": "Education",
      "poi_address": "1101 Herrington Rd, Lawrenceville, GA 30044, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-51de-7279-951e-4cc75a090cd0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-51de-7279-951e-4cc75a090cd0",
        "storage_key": "property/5670511623274496/019f1515-51de-7279-951e-4cc75a090cd0.webp",
        "width": 851,
        "height": 314
      },
      "poi_business_url": "https://www.herringtonacademyeast.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=46876465402219787&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "herrington-academy",
      "poi_latitude": "33.9440543",
      "poi_longitude": "-84.0823352",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 678-377-5633",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-a8a2-73da-b9ec-cea2c1614ed3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-a8a2-73da-b9ec-cea2c1614ed3",
        "storage_key": "property/5670511623274496/019f1515-a8a2-73da-b9ec-cea2c1614ed3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG1IUeb-89YgRCw2gnOWJpgA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_04480da1e4a3a462757bd4db",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Childtime on Patterson Road",
      "poi_type": "Education",
      "poi_address": "20 Patterson Rd SW, Lawrenceville, GA 30044, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-55b5-7563-b7c5-c215c91c48b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-55b5-7563-b7c5-c215c91c48b9",
        "storage_key": "property/5670511623274496/019f1515-55b5-7563-b7c5-c215c91c48b9.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://www.childtime.com/your-local-school/lawrenceville-ga-1110/?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=1110",
      "poi_directions_map_url": "https://maps.google.com/?cid=14189627509030449818&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childtime-on-patterson-road",
      "poi_latitude": "33.9309108",
      "poi_longitude": "-84.0410277",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 877-220-0584",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-a8a2-73da-b9ec-cea2c1614ed3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-a8a2-73da-b9ec-cea2c1614ed3",
        "storage_key": "property/5670511623274496/019f1515-a8a2-73da-b9ec-cea2c1614ed3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVZvMe3K89YgRmvLeIgqv68Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_50ef028a0eece7b2eb213a42",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "AMC Colonial 18",
      "poi_type": "Entertainment",
      "poi_address": "825 Lawrenceville-Suwanee Rd, Lawrenceville, GA 30043, USA",
      "poi_short_description": "Clean outlet featuring recliner seats, a bar and spacious seating.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-6003-763d-a96b-a720d4fd19dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-6003-763d-a96b-a720d4fd19dc",
        "storage_key": "property/5670511623274496/019f1515-6003-763d-a96b-a720d4fd19dc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/atlanta/amc-colonial-18?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=13034783809990546319&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-colonial-18",
      "poi_latitude": "33.96912349999999",
      "poi_longitude": "-84.0193342",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 770-237-0744",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-a896-75d8-bbcf-e6b781796fba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-a896-75d8-bbcf-e6b781796fba",
        "storage_key": "property/5670511623274496/019f1515-a896-75d8-bbcf-e6b781796fba.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5Upu99O99YgRj9N_XtDa5LQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_e38586fe933127f54ec43873",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "AMC Sugarloaf Mills 18",
      "poi_type": "Entertainment",
      "poi_address": "5900 Sugarloaf Pkwy #415, Lawrenceville, GA 30043, USA",
      "poi_short_description": "Modern chain of cinemas featuring plush recliner seats, IMAX and Dolby Cinema experiences, plus snacks.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-64fd-718a-88cc-e6de9b6ed373.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-64fd-718a-88cc-e6de9b6ed373",
        "storage_key": "property/5670511623274496/019f1515-64fd-718a-88cc-e6de9b6ed373.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/atlanta/amc-sugarloaf-mills-18?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=3935803935428528822&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-sugarloaf-mills-18",
      "poi_latitude": "33.9814172",
      "poi_longitude": "-84.07745159999999",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 678-847-9262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-a896-75d8-bbcf-e6b781796fba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-a896-75d8-bbcf-e6b781796fba",
        "storage_key": "property/5670511623274496/019f1515-a896-75d8-bbcf-e6b781796fba.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJs2-hRha99YgRtkrNlNPInjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_e2a429766cd28bf695012f8e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Aurora Theatre",
      "poi_type": "Entertainment",
      "poi_address": "128 E Pike St, Lawrenceville, GA 30046, USA",
      "poi_short_description": "Theater center presenting professional plays, comedy & more on 2 stages in a historic former church.",
      "poi_long_description": "Theater center presenting professional plays, comedy & more on 2 stages in a historic former church.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-72a6-734f-afa5-14179f5db68e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-72a6-734f-afa5-14179f5db68e",
        "storage_key": "property/5670511623274496/019f1515-72a6-734f-afa5-14179f5db68e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.auroratheatre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5723081952526363957&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aurora-theatre",
      "poi_latitude": "33.9572642",
      "poi_longitude": "-83.9872887",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 678-226-6222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca6d-762d-b4f9-1dba867fa9a9",
        "storage_key": "property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ9REL_e-9YgRNW3IsLZ4bE8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_e7b44fe2cfd5e88afb3fb5b2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Local Republic",
      "poi_type": "Entertainment",
      "poi_address": "139 N Perry St, Lawrenceville, GA 30046, USA",
      "poi_short_description": "Industrial-chic space with a seasonal menu of gourmet burgers & small plates plus craft beer & wine.",
      "poi_long_description": "Industrial-chic space with a seasonal menu of gourmet burgers & small plates plus craft beer & wine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-6574-721e-ba94-a3a2b33c996c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-6574-721e-ba94-a3a2b33c996c",
        "storage_key": "property/5670511623274496/019f1515-6574-721e-ba94-a3a2b33c996c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.localrepublic.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=191984735238173216&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "local-republic",
      "poi_latitude": "33.9566272",
      "poi_longitude": "-83.9898643",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 678-205-4782",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-a887-71c3-9c5e-982102634962.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-a887-71c3-9c5e-982102634962",
        "storage_key": "property/5670511623274496/019f1515-a887-71c3-9c5e-982102634962.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP7WW_fO-9YgRIDIrehkRqgI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gastropub"
    },
    {
      "id": "ec_6192ecf257cc93ed28578c3b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Slow Pour Brewing Company",
      "poi_type": "Entertainment",
      "poi_address": "407 N Clayton St, Lawrenceville, GA 30046, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-65c7-71d9-a329-9f3b2c380ae1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-65c7-71d9-a329-9f3b2c380ae1",
        "storage_key": "property/5670511623274496/019f1515-65c7-71d9-a329-9f3b2c380ae1.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "http://slowpourbrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4492681950506932711&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "slow-pour-brewing-company",
      "poi_latitude": "33.9609992",
      "poi_longitude": "-83.98869049999999",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 470-739-0493",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca6d-762d-b4f9-1dba867fa9a9",
        "storage_key": "property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbxJ9Ofa-9YgR51nGRG42WT4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "ec_0bf1f2b570d7f807b143e4e1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Lawrenceville Female Seminary",
      "poi_type": "Entertainment",
      "poi_address": "455 S Perry St, Lawrenceville, GA 30046, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-6249-7482-80a6-214657270b9b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-6249-7482-80a6-214657270b9b",
        "storage_key": "property/5670511623274496/019f1515-6249-7482-80a6-214657270b9b.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://www.gwinnettcounty.com/government/departments/parks-recreation/parks/lawrenceville-female-seminary",
      "poi_directions_map_url": "https://maps.google.com/?cid=10728974623115574342&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lawrenceville-female-seminary",
      "poi_latitude": "33.9525193",
      "poi_longitude": "-83.9889134",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 770-822-5178",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-a8b9-776f-adc7-8afd73018506.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-a8b9-776f-adc7-8afd73018506",
        "storage_key": "property/5670511623274496/019f1515-a8b9-776f-adc7-8afd73018506.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJQWOHyPK_9YgRRvz7PpP55JQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_48791b2a426833360795a39f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Gwinnett Environmental and Heritage Center",
      "poi_type": "Entertainment",
      "poi_address": "Gwinnett Environmental & Heritage Center, 2020 Clean Water Dr, Buford, GA 30519, USA",
      "poi_short_description": "Museum for educational exhibits on environmental topics, plus paved trails.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-749c-7763-a398-d859d740b72f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-749c-7763-a398-d859d740b72f",
        "storage_key": "property/5670511623274496/019f1515-749c-7763-a398-d859d740b72f.webp",
        "width": 1280,
        "height": 832
      },
      "poi_business_url": "https://www.gwinnettcounty.com/government/departments/parks-recreation/parks/gwinnett-environmental-heritage-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=1854322276253968960&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gwinnett-environmental-and-heritage-center",
      "poi_latitude": "34.0639734",
      "poi_longitude": "-84.00459330000001",
      "poi_miles_from_property": "14.8 mi",
      "poi_walking_minutes": "5 hours 33 mins",
      "poi_biking_minutes": "1 hour 30 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 770-904-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca6d-762d-b4f9-1dba867fa9a9",
        "storage_key": "property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWcobgmXs9YgRQCo2H0nguxk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_fcc185e618ca06d8a37f1e78",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Medieval Times Dinner & Tournament",
      "poi_type": "Entertainment",
      "poi_address": "5900 Sugarloaf Pkwy, Lawrenceville, GA 30043, USA",
      "poi_short_description": "Jousting, horsemanship & falconry plus a 4-course, utensil-free meal served in a castle-like space.",
      "poi_long_description": "Jousting, horsemanship & falconry plus a 4-course, utensil-free meal served in a castle-like space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-7321-70a9-abde-476a5bee9250.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-7321-70a9-abde-476a5bee9250",
        "storage_key": "property/5670511623274496/019f1515-7321-70a9-abde-476a5bee9250.webp",
        "width": 664,
        "height": 374
      },
      "poi_business_url": "https://www.medievaltimes.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4422885712143145881&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "medieval-times-dinner--tournament",
      "poi_latitude": "33.980575",
      "poi_longitude": "-84.0798722",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 888-935-6878",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca6d-762d-b4f9-1dba867fa9a9",
        "storage_key": "property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCQ4d6taD3YgRmVtxKh8_YT0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_8c539968aed137d70851cb69",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Dave & Buster's Lawrenceville - Sugarloaf",
      "poi_type": "Entertainment",
      "poi_address": "5900 Sugarloaf Pkwy Ste 441, Lawrenceville, GA 30043, USA",
      "poi_short_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_long_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-882d-7475-b479-38777a52073b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-882d-7475-b479-38777a52073b",
        "storage_key": "property/5670511623274496/019f1512-882d-7475-b479-38777a52073b.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.daveandbusters.com/us/en/about/locations/lawrenceville-sugarloaf",
      "poi_directions_map_url": "https://maps.google.com/?cid=3516378973253059972&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dave--busters-lawrenceville---sugarloaf",
      "poi_latitude": "33.9808546",
      "poi_longitude": "-84.0786662",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 678-847-5400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca6e-77f9-bdee-c480d26855b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca6e-77f9-bdee-c480d26855b3",
        "storage_key": "property/5670511623274496/019f1512-ca6e-77f9-bdee-c480d26855b3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJs2-hRha99YgRhMVmrAuwzDA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_cf5f6246f9195416f8bffc62",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "37 Main Restaurant + Bar",
      "poi_type": "Entertainment",
      "poi_address": "37 E Main St NE, Buford, GA 30518, USA",
      "poi_short_description": "Live local rock bands & touring acts, accompanied by classic American food with a Southern flair.",
      "poi_long_description": "Live local rock bands & touring acts, accompanied by classic American food with a Southern flair.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-73d4-75be-a550-ce5201b6e176.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-73d4-75be-a550-ce5201b6e176",
        "storage_key": "property/5670511623274496/019f1515-73d4-75be-a550-ce5201b6e176.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.37main.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12622678145107244913&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "37-main-restaurant--bar",
      "poi_latitude": "34.1202016",
      "poi_longitude": "-84.005392",
      "poi_miles_from_property": "18.3 mi",
      "poi_walking_minutes": "6 hours 51 mins",
      "poi_biking_minutes": "1 hour 52 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 678-288-2030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-a887-71c3-9c5e-982102634962.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-a887-71c3-9c5e-982102634962",
        "storage_key": "property/5670511623274496/019f1515-a887-71c3-9c5e-982102634962.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx26YxcKT9YgRcTc0KeXCLK8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_060c71c9ae95c627fafa1398",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Northside Hospital Gwinnett",
      "poi_type": "Health and Wellness",
      "poi_address": "1000 Medical Center Blvd, Lawrenceville, GA 30046, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-7514-772c-bed3-280afa736f1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-7514-772c-bed3-280afa736f1a",
        "storage_key": "property/5670511623274496/019f1515-7514-772c-bed3-280afa736f1a.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.northside.com/locations/northside-hospital-gwinnett",
      "poi_directions_map_url": "https://maps.google.com/?cid=4764224694970824387&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northside-hospital-gwinnett",
      "poi_latitude": "33.9633367",
      "poi_longitude": "-84.0175173",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 678-312-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca5e-741c-96a4-228ff06466fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca5e-741c-96a4-228ff06466fa",
        "storage_key": "property/5670511623274496/019f1512-ca5e-741c-96a4-228ff06466fa.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJCQA6O4C-9YgRwzbhPR7tHUI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "ec_74710b0d11ca7d9beadd880d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Northside Urgent Care - Lawrenceville",
      "poi_type": "Health and Wellness",
      "poi_address": "665 Duluth Hwy Ste B, Lawrenceville, GA 30046, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-762b-75c2-884e-2fd696678283.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-762b-75c2-884e-2fd696678283",
        "storage_key": "property/5670511623274496/019f1515-762b-75c2-884e-2fd696678283.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "https://northsideurgentcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12142465372129864594&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northside-urgent-care---lawrenceville",
      "poi_latitude": "33.9662172",
      "poi_longitude": "-84.0090169",
      "poi_miles_from_property": "7.3 mi",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 470-451-0650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca6d-762d-b4f9-1dba867fa9a9",
        "storage_key": "property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtxdhJpi_9YgRkitII-yzgqg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_629eb284a2dc126698dc3c33",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Piedmont Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "3330 Sugarloaf Pkwy, Lawrenceville, GA 30044, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-75d2-7229-b8a1-db5f8b7da2f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-75d2-7229-b8a1-db5f8b7da2f1",
        "storage_key": "property/5670511623274496/019f1515-75d2-7229-b8a1-db5f8b7da2f1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.piedmonturgentcare.org/locations/lawrenceville-ga?location=149&utm_source=rioseo&utm_medium=local&utm_content=clinic_link_149",
      "poi_directions_map_url": "https://maps.google.com/?cid=16676413783155350071&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piedmont-urgent-care",
      "poi_latitude": "33.920575",
      "poi_longitude": "-84.016357",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 678-710-2727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca6d-762d-b4f9-1dba867fa9a9",
        "storage_key": "property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4WhDmKq-9YgRNxpn-PqFbuc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_f851bf4c6c29a69a2b64b4c3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2650 Cruse Rd NW, Lawrenceville, GA 30044, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-430f-7218-847b-38ee6250cb12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-430f-7218-847b-38ee6250cb12",
        "storage_key": "property/5670511623274496/019f1515-430f-7218-847b-38ee6250cb12.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/lawrenceville-ga-pharmacies/2650-cruse-road-lawrenceville-ga-30044/storeid=2570?WT.mc_id=LS_GOOGLE_RX_2570",
      "poi_directions_map_url": "https://maps.google.com/?cid=13284165219801309726&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "33.9393659",
      "poi_longitude": "-84.0817644",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 770-921-8514",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-a86c-719c-8af4-4342f36bb081.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-a86c-719c-8af4-4342f36bb081",
        "storage_key": "property/5670511623274496/019f1515-a86c-719c-8af4-4342f36bb081.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF2LEc7689YgRHiLbh-LVWrg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_0223d176cb5aec31c2a7a3dd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "181 S Clayton St, Lawrenceville, GA 30046, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-7a7a-752f-be39-591b6037fe71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-7a7a-752f-be39-591b6037fe71",
        "storage_key": "property/5670511623274496/019f1515-7a7a-752f-be39-591b6037fe71.webp",
        "width": 1280,
        "height": 775
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-181+s+clayton+st-lawrenceville-ga-30046/id=5899",
      "poi_directions_map_url": "https://maps.google.com/?cid=10649464197086289386&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "33.947374",
      "poi_longitude": "-83.98694069999999",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 770-962-0912",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca6d-762d-b4f9-1dba867fa9a9",
        "storage_key": "property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJewX-EO--9YgR6p2Rk0N_ypM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_55426b95461ff613f05885b7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Onelife Fitness Lawrenceville",
      "poi_type": "Health and Wellness",
      "poi_address": "860 Duluth Hwy Ste. 1100, Lawrenceville, GA 30043, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-7a5a-729a-9252-85dd364d42e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-7a5a-729a-9252-85dd364d42e0",
        "storage_key": "property/5670511623274496/019f1515-7a5a-729a-9252-85dd364d42e0.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://www.onelifefitness.com/gyms/lawrenceville",
      "poi_directions_map_url": "https://maps.google.com/?cid=5329385660287081261&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "onelife-fitness-lawrenceville",
      "poi_latitude": "33.9653623",
      "poi_longitude": "-84.0213212",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 770-817-1650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca6d-762d-b4f9-1dba867fa9a9",
        "storage_key": "property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpxyNXNO99YgRLdt4kAXI9Uk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_2ecea4b9b102c3de92927599",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "600 Gwinnett Dr, Lawrenceville, GA 30045, USA",
      "poi_short_description": "Chain health club offering state-of-the-art equipment, plus basketball and swimming pools.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ab51-72ce-9c34-76daf3834e40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-ab51-72ce-9c34-76daf3834e40",
        "storage_key": "property/5670511623274496/019f1512-ab51-72ce-9c34-76daf3834e40.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=1270&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=12055086857226827692&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "33.9409123",
      "poi_longitude": "-83.98465829999999",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 470-222-2009",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca6d-762d-b4f9-1dba867fa9a9",
        "storage_key": "property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLTqB4e6_9YgRrDd8RaBFTKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_cf6d4023506753960d1c04b9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "1823 N Brown Rd, Lawrenceville, GA 30043, USA",
      "poi_short_description": "Workout complex known for its basketball facilities, pool, hot tub and rock climbing apparatus, with an on-site cafe.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-9ce0-718b-8cef-6abe36412e8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-9ce0-718b-8cef-6abe36412e8c",
        "storage_key": "property/5670511623274496/019f1512-9ce0-718b-8cef-6abe36412e8c.webp",
        "width": 1088,
        "height": 1088
      },
      "poi_business_url": "https://www.lifetime.life/locations/ga/sugarloaf.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=660008906064559403&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "33.9859758",
      "poi_longitude": "-84.08296729999999",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 678-226-2099",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca6d-762d-b4f9-1dba867fa9a9",
        "storage_key": "property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK5XkThW99YgRK32SaprSKAk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_19aa300769489a0faec3d48c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1250 Scenic Hwy S #1264, Lawrenceville, GA 30045, USA",
      "poi_short_description": "An hour-long workout studio involving cardio and strength training and featuring a heart-rate monitor.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-8055-744c-811f-842596130c14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-8055-744c-811f-842596130c14",
        "storage_key": "property/5670511623274496/019f1515-8055-744c-811f-842596130c14.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/lawrenceville-georgia-0271?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=13903466271609691504&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "33.8993676",
      "poi_longitude": "-84.004694",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 770-450-1234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca6d-762d-b4f9-1dba867fa9a9",
        "storage_key": "property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXYPZG0O59YgRcJ3rCekI88A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_9050001b896fa7ee8a021f11",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Club Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "1350 Scenic Hwy N Ste 620, Snellville, GA 30078, USA",
      "poi_short_description": "Boutique studio for reformer Pilates and fusion classes, featuring helpful staff.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-7e98-70b0-b275-8baf7d16a209.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-7e98-70b0-b275-8baf7d16a209",
        "storage_key": "property/5670511623274496/019f1515-7e98-70b0-b275-8baf7d16a209.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://clubpilates.com/snellville/?utm_source=google.com&utm_medium=referral&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=18095852761116136215&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "club-pilates",
      "poi_latitude": "33.8983281",
      "poi_longitude": "-84.00399639999999",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 770-674-6767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-a8a2-73da-b9ec-cea2c1614ed3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-a8a2-73da-b9ec-cea2c1614ed3",
        "storage_key": "property/5670511623274496/019f1515-a8a2-73da-b9ec-cea2c1614ed3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJuxx0l_K59YgRF1MZ1jViIfs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_4029cdf9206abd1a5356a8e4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Bethesda Park & Aquatic Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "225 Bethesda Church Rd, Lawrenceville, GA 30044, USA",
      "poi_short_description": "Recreation area with 159 acres of paved trails, sports fields, senior center & indoor aquatics.",
      "poi_long_description": "Recreation area with 159 acres of paved trails, sports fields, senior center & indoor aquatics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-b1a4-71d4-8cfc-4bae48c2d75c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-b1a4-71d4-8cfc-4bae48c2d75c",
        "storage_key": "property/5670511623274496/019f1512-b1a4-71d4-8cfc-4bae48c2d75c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.gwinnettcounty.com/government/departments/parks-recreation/parks/bethesda",
      "poi_directions_map_url": "https://maps.google.com/?cid=11373234233299565963&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bethesda-park--aquatic-center",
      "poi_latitude": "33.9019329",
      "poi_longitude": "-84.0886366",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 678-277-0179",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca5c-700b-91d8-36951477f4ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca5c-700b-91d8-36951477f4ce",
        "storage_key": "property/5670511623274496/019f1512-ca5c-700b-91d8-36951477f4ce.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_WeJNEa79YgRi_0h90bY1Z0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_63880c83f9b72ae0aba27d16",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Sweet Water Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "800 Bethesda School Rd, Lawrenceville, GA 30044, USA",
      "poi_short_description": "25-acre park with a playground for kids plus basketball, tennis & volleyball courts for adults.",
      "poi_long_description": "25-acre park with a playground for kids plus basketball, tennis & volleyball courts for adults.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-836a-76ea-b1f1-1e0504e4af72.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-836a-76ea-b1f1-1e0504e4af72",
        "storage_key": "property/5670511623274496/019f1515-836a-76ea-b1f1-1e0504e4af72.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.gwinnettcounty.com/government/departments/parks-recreation/parks/sweet-water",
      "poi_directions_map_url": "https://maps.google.com/?cid=10379037501573355575&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sweet-water-park",
      "poi_latitude": "33.9371148",
      "poi_longitude": "-84.07826089999999",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 678-277-0179",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca5c-700b-91d8-36951477f4ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca5c-700b-91d8-36951477f4ce",
        "storage_key": "property/5670511623274496/019f1512-ca5c-700b-91d8-36951477f4ce.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJcQMnKJa89YgRN9i8_52_CZA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_ab2179bd88eae7922af02743",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Alexander Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "800 Old Snellville Hwy, Lawrenceville, GA 30044, USA",
      "poi_short_description": "Scenic spot featuring a flying-disc golf course, trails, fishing, a horseshoe pit & a playground.",
      "poi_long_description": "Scenic spot featuring a flying-disc golf course, trails, fishing, a horseshoe pit & a playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-b9d1-775e-b79a-19b1442cb1e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-b9d1-775e-b79a-19b1442cb1e6",
        "storage_key": "property/5670511623274496/019f1512-b9d1-775e-b79a-19b1442cb1e6.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.gwinnettcounty.com/government/departments/parks-recreation/parks/alexander",
      "poi_directions_map_url": "https://maps.google.com/?cid=15642129952374157231&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alexander-park",
      "poi_latitude": "33.9158646",
      "poi_longitude": "-84.00712460000001",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 678-277-0890",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca5c-700b-91d8-36951477f4ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca5c-700b-91d8-36951477f4ce",
        "storage_key": "property/5670511623274496/019f1512-ca5c-700b-91d8-36951477f4ce.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJjz59iVK59YgRr2_C7VACFNk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_c7901a670aafe91f8e12d846",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Ronald Reagan Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2777 Five Forks Trickum Rd SW, Lawrenceville, GA 30044, USA",
      "poi_short_description": "Tranquil open space with a playground, picnic pavilions, sport courts, a skate park & a dog area.",
      "poi_long_description": "Tranquil open space with a playground, picnic pavilions, sport courts, a skate park & a dog area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-817c-75fa-b50f-a158ec8d4e56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-817c-75fa-b50f-a158ec8d4e56",
        "storage_key": "property/5670511623274496/019f1515-817c-75fa-b50f-a158ec8d4e56.webp",
        "width": 1280,
        "height": 832
      },
      "poi_business_url": "https://www.gwinnettcounty.com/government/departments/parks-recreation/parks/ronald-reagan",
      "poi_directions_map_url": "https://maps.google.com/?cid=3821816117617478758&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ronald-reagan-park",
      "poi_latitude": "33.8951138",
      "poi_longitude": "-84.0561026",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 678-277-0179",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca5c-700b-91d8-36951477f4ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca5c-700b-91d8-36951477f4ce",
        "storage_key": "property/5670511623274496/019f1512-ca5c-700b-91d8-36951477f4ce.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJNc1A6aC79YgRZsxzl4LRCTU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_a634135d7b0df796f81feb40",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Rhodes Jordan Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "100 E Crogan St, Lawrenceville, GA 30046, USA",
      "poi_short_description": "Public space featuring a lake, an aquatic center, sports fields, picnic areas & a community center.",
      "poi_long_description": "Public space featuring a lake, an aquatic center, sports fields, picnic areas & a community center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-7fa5-713c-8a04-d3f021744de7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-7fa5-713c-8a04-d3f021744de7",
        "storage_key": "property/5670511623274496/019f1515-7fa5-713c-8a04-d3f021744de7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.gwinnettcounty.com/government/departments/parks-recreation/parks/rhodes-jordan",
      "poi_directions_map_url": "https://maps.google.com/?cid=14240515538640947205&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rhodes-jordan-park",
      "poi_latitude": "33.9569714",
      "poi_longitude": "-83.979016",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 678-277-0890",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca5c-700b-91d8-36951477f4ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca5c-700b-91d8-36951477f4ce",
        "storage_key": "property/5670511623274496/019f1512-ca5c-700b-91d8-36951477f4ce.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJFXzjrf6-9YgRBcgf0255oMU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_3fbfecba68c295bb8c1771ad",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Freeman's Mill Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1401 Alcovy Rd SE, Lawrenceville, GA 30045, USA",
      "poi_short_description": "12-acre county park featuring a restored historic gristmill, a playground & multipurpose trail.",
      "poi_long_description": "12-acre county park featuring a restored historic gristmill, a playground & multipurpose trail.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-889e-73c8-9f0b-83dc05fa8065.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-889e-73c8-9f0b-83dc05fa8065",
        "storage_key": "property/5670511623274496/019f1515-889e-73c8-9f0b-83dc05fa8065.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.gwinnettcounty.com/government/departments/parks-recreation/parks/freemans-mill",
      "poi_directions_map_url": "https://maps.google.com/?cid=6838945116331094222&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "freemans-mill-park",
      "poi_latitude": "33.9633295",
      "poi_longitude": "-83.9247335",
      "poi_miles_from_property": "11.9 mi",
      "poi_walking_minutes": "4 hours 30 mins",
      "poi_biking_minutes": "1 hour 18 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 770-822-5178",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca5c-700b-91d8-36951477f4ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca5c-700b-91d8-36951477f4ce",
        "storage_key": "property/5670511623274496/019f1512-ca5c-700b-91d8-36951477f4ce.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJWRgxhH7A9YgRzrBOWVnQ6F4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_4b2e320b5afc734af4af804b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Dacula Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "205 Dacula Rd, Dacula, GA 30019, USA",
      "poi_short_description": "Large outdoor activity space with a pool & 7 baseball fields, plus a large pavilion & playgrounds.",
      "poi_long_description": "Large outdoor activity space with a pool & 7 baseball fields, plus a large pavilion & playgrounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-8907-70a6-b8e2-744e58cf5645.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-8907-70a6-b8e2-744e58cf5645",
        "storage_key": "property/5670511623274496/019f1515-8907-70a6-b8e2-744e58cf5645.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.gwinnettcounty.com/government/departments/parks-recreation/parks/dacula",
      "poi_directions_map_url": "https://maps.google.com/?cid=5470852604713861603&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dacula-park",
      "poi_latitude": "33.994264",
      "poi_longitude": "-83.89708300000001",
      "poi_miles_from_property": "15.5 mi",
      "poi_walking_minutes": "5 hours 48 mins",
      "poi_biking_minutes": "1 hour 31 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 678-277-0890",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca5c-700b-91d8-36951477f4ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca5c-700b-91d8-36951477f4ce",
        "storage_key": "property/5670511623274496/019f1512-ca5c-700b-91d8-36951477f4ce.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJz28vny_A9YgR44F9SnVf7Es",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_fd69b946f1fa561289ab2247",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Rabbit Hill Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "400 Rabbit Hill Rd, Dacula, GA 30019, USA",
      "poi_short_description": "Public recreation area featuring a sand volleyball court, soccer fields, a dog park & paved trails.",
      "poi_long_description": "Public recreation area featuring a sand volleyball court, soccer fields, a dog park & paved trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-8689-743f-a7a2-8ae2e8271201.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-8689-743f-a7a2-8ae2e8271201",
        "storage_key": "property/5670511623274496/019f1515-8689-743f-a7a2-8ae2e8271201.webp",
        "width": 1280,
        "height": 832
      },
      "poi_business_url": "https://www.gwinnettcounty.com/government/departments/parks-recreation/parks/rabbit-hill",
      "poi_directions_map_url": "https://maps.google.com/?cid=13841134794369490818&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rabbit-hill-park",
      "poi_latitude": "33.9987007",
      "poi_longitude": "-83.93258610000001",
      "poi_miles_from_property": "13.3 mi",
      "poi_walking_minutes": "5 hours 0 mins",
      "poi_biking_minutes": "1 hour 20 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 678-277-0890",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca5c-700b-91d8-36951477f4ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca5c-700b-91d8-36951477f4ce",
        "storage_key": "property/5670511623274496/019f1512-ca5c-700b-91d8-36951477f4ce.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZy_oCQPA9YgRgl-xEsOWFcA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_76fcf69508bf8596931ce6c5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Sugarloaf Mills Park/Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "1905 N Brown Rd, Lawrenceville, GA 30043, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-8435-721f-add4-f99a056d8c47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-8435-721f-add4-f99a056d8c47",
        "storage_key": "property/5670511623274496/019f1515-8435-721f-add4-f99a056d8c47.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gwinnettcounty.com/portal/gwinnett/Departments/Transportation/GwinnettCountyTransit",
      "poi_directions_map_url": "https://maps.google.com/?cid=16218795295653938135&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sugarloaf-mills-parkride",
      "poi_latitude": "33.9834908",
      "poi_longitude": "-84.08409499999999",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 770-822-5010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-a892-759b-8a4a-bfba98287df7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-a892-759b-8a4a-bfba98287df7",
        "storage_key": "property/5670511623274496/019f1515-a892-759b-8a4a-bfba98287df7.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJY5Ms6j699YgR18M6-mO8FOE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_570e4d2b6625b34e77210602",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Sugarloaf Mills",
      "poi_type": "Transportation & Transit",
      "poi_address": "5900 Sugarloaf Pkwy, Lawrenceville, GA 30043, USA",
      "poi_short_description": "Large indoor shopping mall features familiar chain retailers, dozens of eateries & a movie theater.",
      "poi_long_description": "Large indoor shopping mall features familiar chain retailers, dozens of eateries & a movie theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-8f99-70de-946b-1b6ae11e07f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-8f99-70de-946b-1b6ae11e07f1",
        "storage_key": "property/5670511623274496/019f1512-8f99-70de-946b-1b6ae11e07f1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.simon.com/mall/sugarloaf-mills",
      "poi_directions_map_url": "https://maps.google.com/?cid=14621995137507182859&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sugarloaf-mills",
      "poi_latitude": "33.9806714",
      "poi_longitude": "-84.0809653",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 470-665-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca61-714b-8496-8f509ad15d4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca61-714b-8496-8f509ad15d4e",
        "storage_key": "property/5670511623274496/019f1512-ca61-714b-8496-8f509ad15d4e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJvffBmj299YgRC8maXhvD68o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_d31beb10e18df8f9a6e2f1d1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Gwinnett County Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "3486 Satellite Blvd NW #3478, Duluth, GA 30096, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-8f48-74d9-bc5c-2c81f73237cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-8f48-74d9-bc5c-2c81f73237cd",
        "storage_key": "property/5670511623274496/019f1515-8f48-74d9-bc5c-2c81f73237cd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.gctransit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3216275387600768926&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gwinnett-county-transit-center",
      "poi_latitude": "33.9631555",
      "poi_longitude": "-84.1312757",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 770-822-5010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca6d-762d-b4f9-1dba867fa9a9",
        "storage_key": "property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnen6Yxuj9YgRno_GqWyBoiw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_7174e0b242f6310695452955",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Gwinnett County Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "3486 Satellite Blvd NW #3478, Duluth, GA 30096, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-8e0c-7641-ba27-e2578f7c8753.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-8e0c-7641-ba27-e2578f7c8753",
        "storage_key": "property/5670511623274496/019f1515-8e0c-7641-ba27-e2578f7c8753.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.gctransit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3216275387600768926&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gwinnett-county-transit-center",
      "poi_latitude": "33.9631555",
      "poi_longitude": "-84.1312757",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 770-822-5010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca6d-762d-b4f9-1dba867fa9a9",
        "storage_key": "property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnen6Yxuj9YgRno_GqWyBoiw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_181628e01bea92857553d5dd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Indian Trail Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Norcross (E, Norcross, GA 30071, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7607139053044866047&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "indian-trail-park-and-ride",
      "poi_latitude": "33.930052",
      "poi_longitude": "-84.174413",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca6d-762d-b4f9-1dba867fa9a9",
        "storage_key": "property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK1mz7uOj9YgR_5u9Far8kWk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_0d961386fb329e3275fec52f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Gwinnett County Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "3486 Satellite Blvd NW #3478, Duluth, GA 30096, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-8f35-73aa-8d3a-3803f5410592.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-8f35-73aa-8d3a-3803f5410592",
        "storage_key": "property/5670511623274496/019f1515-8f35-73aa-8d3a-3803f5410592.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.gctransit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3216275387600768926&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gwinnett-county-transit-center",
      "poi_latitude": "33.9631555",
      "poi_longitude": "-84.1312757",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 770-822-5010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca6d-762d-b4f9-1dba867fa9a9",
        "storage_key": "property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnen6Yxuj9YgRno_GqWyBoiw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_90e48eaa6192ff9f8d4e2499",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "I-985 Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Buford, GA 30519, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-9458-75cd-8edc-58bcdc99a860.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-9458-75cd-8edc-58bcdc99a860",
        "storage_key": "property/5670511623274496/019f1515-9458-75cd-8edc-58bcdc99a860.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11226966607402476044&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "i-985-park-and-ride",
      "poi_latitude": "34.08508",
      "poi_longitude": "-83.9952",
      "poi_miles_from_property": "15.8 mi",
      "poi_walking_minutes": "5 hours 54 mins",
      "poi_biking_minutes": "1 hour 33 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca6d-762d-b4f9-1dba867fa9a9",
        "storage_key": "property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa1yJrnKU9YgRDKJle6Uyzps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_5b46f81e9520bd159e8b5ec7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Doraville",
      "poi_type": "Transportation & Transit",
      "poi_address": "6000 New Peachtree Rd, Doraville, GA 30340, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-9007-705d-9d00-c97cb869c514.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-9007-705d-9d00-c97cb869c514",
        "storage_key": "property/5670511623274496/019f1515-9007-705d-9d00-c97cb869c514.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.itsmarta.com/Doraville.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=7112078237771489928&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "doraville",
      "poi_latitude": "33.9029638",
      "poi_longitude": "-84.2801456",
      "poi_miles_from_property": "15.1 mi",
      "poi_walking_minutes": "5 hours 41 mins",
      "poi_biking_minutes": "1 hour 40 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 404-848-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca6d-762d-b4f9-1dba867fa9a9",
        "storage_key": "property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ5SGscQJ9YgRiOIn0Xkts2I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "ec_87acec01d212028a72253e04",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Lindbergh Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "2424 Piedmont Rd NE, Atlanta, GA 30324, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-9450-73dc-9024-e744f96a777b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-9450-73dc-9024-e744f96a777b",
        "storage_key": "property/5670511623274496/019f1515-9450-73dc-9024-e744f96a777b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://itsmarta.com/Lindbergh.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=632507744447004235&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lindbergh-center",
      "poi_latitude": "33.8231157",
      "poi_longitude": "-84.36943869999999",
      "poi_miles_from_property": "20.5 mi",
      "poi_walking_minutes": "7 hours 41 mins",
      "poi_biking_minutes": "2 hours 37 mins",
      "poi_driving_minutes": "33 mins",
      "poi_business_phone": "+1 404-848-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca6d-762d-b4f9-1dba867fa9a9",
        "storage_key": "property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo8oZEMIF9YgRS35yQXEexwg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "ec_eccb8ca36775c603657c76aa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Hartsfield-Jackson Atlanta International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "6000 N Terminal Pkwy Ste 4000, Atlanta, GA 30320, USA",
      "poi_short_description": "This hub featuring 250+ pieces of art & occasional live music is one of the busiest in the world.",
      "poi_long_description": "This hub featuring 250+ pieces of art & occasional live music is one of the busiest in the world.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-9372-731d-b325-23090f279c51.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-9372-731d-b325-23090f279c51",
        "storage_key": "property/5670511623274496/019f1515-9372-731d-b325-23090f279c51.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "https://www.atl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4690397784234438728&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hartsfield-jackson-atlanta-international-airport",
      "poi_latitude": "33.6324187",
      "poi_longitude": "-84.4333116",
      "poi_miles_from_property": "36.3 mi",
      "poi_walking_minutes": "13 hours 35 mins",
      "poi_biking_minutes": "3 hours 57 mins",
      "poi_driving_minutes": "47 mins",
      "poi_business_phone": "+1 800-897-1910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-a8a4-77b5-ab96-91a6ed1333bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-a8a4-77b5-ab96-91a6ed1333bc",
        "storage_key": "property/5670511623274496/019f1515-a8a4-77b5-ab96-91a6ed1333bc.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJAVkD4S_99IgRSLCSGO-jF0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_fdd57c5d143d352049b05f31",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Northside Hospital Gwinnett",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1000 Medical Center Blvd, Lawrenceville, GA 30046, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-7514-772c-bed3-280afa736f1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-7514-772c-bed3-280afa736f1a",
        "storage_key": "property/5670511623274496/019f1515-7514-772c-bed3-280afa736f1a.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.northside.com/locations/northside-hospital-gwinnett",
      "poi_directions_map_url": "https://maps.google.com/?cid=4764224694970824387&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northside-hospital-gwinnett",
      "poi_latitude": "33.9633367",
      "poi_longitude": "-84.0175173",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 678-312-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca5e-741c-96a4-228ff06466fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca5e-741c-96a4-228ff06466fa",
        "storage_key": "property/5670511623274496/019f1512-ca5e-741c-96a4-228ff06466fa.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJCQA6O4C-9YgRwzbhPR7tHUI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "ec_84c0feb9312ba90eb32efdcb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Georgia Gwinnett College",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1000 University Center Ln, Lawrenceville, GA 30043, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-581c-739d-8175-9903561ddafd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-581c-739d-8175-9903561ddafd",
        "storage_key": "property/5670511623274496/019f1515-581c-739d-8175-9903561ddafd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ggc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17256186828481170101&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgia-gwinnett-college",
      "poi_latitude": "33.9802966",
      "poi_longitude": "-84.0047709",
      "poi_miles_from_property": "9.0 mi",
      "poi_walking_minutes": "3 hours 23 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 678-407-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-a8a2-73da-b9ec-cea2c1614ed3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-a8a2-73da-b9ec-cea2c1614ed3",
        "storage_key": "property/5670511623274496/019f1515-a8a2-73da-b9ec-cea2c1614ed3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQyGfL2y-9YgRtQplSX5Keu8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_1169449b463cf2eb1329cad9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Gwinnett Justice and Administration Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "75 Langley Dr, Lawrenceville, GA 30046, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-9838-70ae-b220-67de986d2b6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-9838-70ae-b220-67de986d2b6d",
        "storage_key": "property/5670511623274496/019f1515-9838-70ae-b220-67de986d2b6d.webp",
        "width": 1280,
        "height": 866
      },
      "poi_business_url": "https://www.gwinnettcounty.com/home",
      "poi_directions_map_url": "https://maps.google.com/?cid=17626886500500162398&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gwinnett-justice-and-administration-center",
      "poi_latitude": "33.9506177",
      "poi_longitude": "-83.9942748",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 770-822-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-a891-700a-bb31-feab2f96cad5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-a891-700a-bb31-feab2f96cad5",
        "storage_key": "property/5670511623274496/019f1515-a891-700a-bb31-feab2f96cad5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWWr2Ku2-9YgRXsdwhuFHn_Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_fc3661f658ab31c57f2bcc31",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "One Justice Square",
      "poi_type": "Major Employers & Offices",
      "poi_address": "446 W Crogan St, Lawrenceville, GA 30046, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-97c6-7389-8de8-3498acbe2186.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-97c6-7389-8de8-3498acbe2186",
        "storage_key": "property/5670511623274496/019f1515-97c6-7389-8de8-3498acbe2186.webp",
        "width": 961,
        "height": 1280
      },
      "poi_business_url": "https://www.gwinnettcounty.com/web/gwinnett/contactus/onejusticesquare",
      "poi_directions_map_url": "https://maps.google.com/?cid=15717508763658292381&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "one-justice-square",
      "poi_latitude": "33.9518503",
      "poi_longitude": "-83.99648599999999",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-a891-700a-bb31-feab2f96cad5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-a891-700a-bb31-feab2f96cad5",
        "storage_key": "property/5670511623274496/019f1515-a891-700a-bb31-feab2f96cad5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvRvQEOi_9YgRnQzxE_LOH9o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "ec_a99c6e4639399ab40331732b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Gwinnett Technical College",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5150 Sugarloaf Pkwy, Lawrenceville, GA 30043, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-978b-7769-bb75-1ef1f1b4e576.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-978b-7769-bb75-1ef1f1b4e576",
        "storage_key": "property/5670511623274496/019f1515-978b-7769-bb75-1ef1f1b4e576.webp",
        "width": 1280,
        "height": 513
      },
      "poi_business_url": "https://www.gwinnetttech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7799353580243192100&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gwinnett-technical-college",
      "poi_latitude": "33.9626759",
      "poi_longitude": "-84.0659464",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 770-962-7580",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-a8a2-73da-b9ec-cea2c1614ed3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-a8a2-73da-b9ec-cea2c1614ed3",
        "storage_key": "property/5670511623274496/019f1515-a8a2-73da-b9ec-cea2c1614ed3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEX_yD_289YgRJAkRLMLePGw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "ec_0a497c095a64c2868c964397",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Gwinnett County Public Schools ISC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "437 Old Peachtree Rd NW #2978, Suwanee, GA 30024, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-9897-754c-ba97-518265866385.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-9897-754c-ba97-518265866385",
        "storage_key": "property/5670511623274496/019f1515-9897-754c-ba97-518265866385.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://www.gcpsk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3816551784026628797&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gwinnett-county-public-schools-isc",
      "poi_latitude": "34.0156594",
      "poi_longitude": "-84.0567295",
      "poi_miles_from_property": "8.9 mi",
      "poi_walking_minutes": "3 hours 20 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 678-301-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-a8a2-73da-b9ec-cea2c1614ed3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-a8a2-73da-b9ec-cea2c1614ed3",
        "storage_key": "property/5670511623274496/019f1515-a8a2-73da-b9ec-cea2c1614ed3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDcGQjiyW9YgRvWLKaaAd9zQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_ff359eab3556661477b8e649",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Piedmont Eastside Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1700 Medical Way, Snellville, GA 30078, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ac8c-706b-901c-89900af5ea1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1512-ac8c-706b-901c-89900af5ea1f",
        "storage_key": "property/5670511623274496/019f1512-ac8c-706b-901c-89900af5ea1f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.piedmont.org/locations/piedmont-eastside-medical-center?utm_source=directorylisting&utm_medium=seo&utm_campaign=10223&y_source=1_MjY4OTU4ODctNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=8293276328954316881&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piedmont-eastside-medical-center",
      "poi_latitude": "33.8769038",
      "poi_longitude": "-84.0210179",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 770-979-0200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca5e-741c-96a4-228ff06466fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca5e-741c-96a4-228ff06466fa",
        "storage_key": "property/5670511623274496/019f1512-ca5e-741c-96a4-228ff06466fa.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJP_cKkNS79YgRUUh6q-GiF3M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_e1adb187fc9699f641ea4c93",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Mall of Georgia",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3333 Buford Dr, Buford, GA 30519, USA",
      "poi_short_description": "Landmark mall with grand architecture & 200+ stores on 3 levels, plus a cinema & kids’ play area.",
      "poi_long_description": "Landmark mall with grand architecture & 200+ stores on 3 levels, plus a cinema & kids’ play area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-9b4c-719f-b799-f88defb6d5f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-9b4c-719f-b799-f88defb6d5f8",
        "storage_key": "property/5670511623274496/019f1515-9b4c-719f-b799-f88defb6d5f8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.simon.com/mall/mall-of-georgia",
      "poi_directions_map_url": "https://maps.google.com/?cid=11636229521613497056&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mall-of-georgia",
      "poi_latitude": "34.0651406",
      "poi_longitude": "-83.9844837",
      "poi_miles_from_property": "16.5 mi",
      "poi_walking_minutes": "6 hours 10 mins",
      "poi_biking_minutes": "1 hour 30 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 678-482-8788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca61-714b-8496-8f509ad15d4e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca61-714b-8496-8f509ad15d4e",
        "storage_key": "property/5670511623274496/019f1512-ca61-714b-8496-8f509ad15d4e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJf04EMFuU9YgR4KKvOBkxfKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_1c84bbcaceaa79fbc0220b7e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Children's Healthcare of Atlanta Cardiology - Lawrenceville",
      "poi_type": "Major Employers & Offices",
      "poi_address": "771 Old Norcross Rd Ste 110, Lawrenceville, GA 30046, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-a026-7329-9987-6a9cd226e505.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-a026-7329-9987-6a9cd226e505",
        "storage_key": "property/5670511623274496/019f1515-a026-7329-9987-6a9cd226e505.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.choa.org/cardiology",
      "poi_directions_map_url": "https://maps.google.com/?cid=15119608663590530467&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-healthcare-of-atlanta-cardiology---lawrenceville",
      "poi_latitude": "33.9583957",
      "poi_longitude": "-84.01732249999999",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 404-256-2593",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1512-ca6d-762d-b4f9-1dba867fa9a9",
        "storage_key": "property/5670511623274496/019f1512-ca6d-762d-b4f9-1dba867fa9a9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ27cpm4G-9YgRo2078Pij09E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "doctor"
    },
    {
      "id": "ec_26e7cdb9a4bcb68cef744811",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "poi_name": "Gwinnett County Police Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "770 Hi Hope Rd, Lawrenceville, GA 30043, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-9ce5-738c-a9ef-cc6ef942c8a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1515-9ce5-738c-a9ef-cc6ef942c8a0",
        "storage_key": "property/5670511623274496/019f1515-9ce5-738c-a9ef-cc6ef942c8a0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.gwinnettcounty.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5914580209032225706&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gwinnett-county-police-headquarters",
      "poi_latitude": "33.9871782",
      "poi_longitude": "-83.97304989999999",
      "poi_miles_from_property": "10.2 mi",
      "poi_walking_minutes": "3 hours 51 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 770-513-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f1515-a891-700a-bb31-feab2f96cad5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1515-a891-700a-bb31-feab2f96cad5",
        "storage_key": "property/5670511623274496/019f1515-a891-700a-bb31-feab2f96cad5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbfQVF8u_9YgRquPrAl3PFFI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_ed8971c4-ab11-479f-b351-bae98a2fabfa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_605c2203-d13e-4535-9848-cee718fbacb9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_653148f3-b6bc-4678-b41a-22f12d92d2ca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_6e783e46-7500-4690-acdc-5a1e04c40d9d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_6736491b-b71d-498a-954a-2205b581e0c5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_ac204ea9-9d0a-44c7-aae6-1e20c7b71966",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_4f9e84b4-fbc0-4821-940c-8e80c7be3da4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "rating": "5.0",
      "name": "PrettiDrea",
      "text": "Move process was a little complicated for me but Kiara was the best!!! Her communication was beyond great and the process turned to be the smoothest ever.. Thanks to her.. My apartment is beautiful and I love the peace and quietness here. I would recommend.",
      "date": "2026-05-19",
      "title": ""
    },
    {
      "id": "custom_2ea0867e-a784-45ad-9b39-24cc7622be17",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "rating": "5.0",
      "name": "Katherine",
      "text": "Living at Artistry at Bethesda has been a great experience. The maintenance team is super responsive, professional, and always gets things handled quickly. The gym is honestly like no other I’ve seen at any apartment — fully equipped, not with just a treadmill, but with multiple weight machines and well kept. I also love the outdoor playground areas for when my grandchildren visit, and dog park area, which make the community feel very complete.\n\nThey also have a program called ‘flex rent’ that for when hard times hit, it gives you flexible options to pay your rent while at the same time building your credit history. I mean come on, what more could you ask?\n\nThe staff is friendly and helpful, and it’s clear they take pride in keeping the property in top shape. If you’re looking for a place where management actually cares and maintenance shows up when you need them, Artistry at Bethesda is a fantastic choice. Highly recommend!",
      "date": "2026-02-25",
      "title": ""
    },
    {
      "id": "custom_9066eba1-167c-4dc5-ab17-a6bd0c294b22",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "rating": "5.0",
      "name": "Sabrina Williams",
      "text": "Let me start by saying this is the most quiet & laid back properties I’ve ever lived in. Its clean, and Kiara is heaven sent I was going through a tough time and she helped me with my approval, I just renewed my lease & it only went up $18!!! I love it here spacious and no bugs 💕",
      "date": "2026-03-24",
      "title": ""
    },
    {
      "id": "custom_e902c8ec-6208-4409-bdec-c13e346912df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "rating": "5.0",
      "name": "Maria C",
      "text": "I walked in with no appointment on a Monday afternoon feeling stressed and honestly with very little to no hope on finding an apartment that would fit my budget and needs. However, Ms. Kiara greeted me with so much kindness and professionalism she showed me the model unit, which I instantly fell in love with.\n\nNot to mention she was working the office by herself that day and still handled everyone with so much patience and professionalism. Even though she was busy, she made sure everyone felt taken care of.\n\nShe’s truly an amazing asset to the company and deserves the recognition.\n\nI was a little skeptical at first, but I submitted my application today. I haven’t even moved in and I’m already excited!!",
      "date": "2026-01-05",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_9be65193fddc5f57f61ec469",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019d02f0-8e2d-74b4-ab2e-f06ec95dd772.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Hallway view towards kitchen and dining area with closed doors on either side.",
        "public_id": "019d02f0-8e2d-74b4-ab2e-f06ec95dd772",
        "storage_key": "property/5670511623274496/019d02f0-8e2d-74b4-ab2e-f06ec95dd772.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Artistry At Bethesda",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=3QB58nTcAdg"
    }
  ],
  "faqs": [
    {
      "id": "custom_459049b9-1939-4b40-8bcb-dcc14aaf68a9",
      "question": "Is Artistry at Bethesda Park pet-friendly?",
      "answer": "Yes. Artistry at Bethesda Park welcomes cats and dogs, up to 2 pets per home, with no posted weight limit. Some breed restrictions apply. Assistance animals (service animals and emotional support animals) are not pets under fair housing law, so they are not subject to pet fees, deposits, or breed and weight restrictions. For the full pet policy, call the leasing team at (770) 921-7794 or visit our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_aa5b5c64-067f-4013-868e-92e763ad37ee",
      "question": "How can I schedule a tour at Artistry at Bethesda Park?",
      "answer": "You can schedule a tour of Artistry at Bethesda Park online through our Schedule a Tour page, or call the leasing office at (770) 921-7794. You can also view our virtual tours to see the community before visiting in person.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_99753723-3e43-4e81-944c-bb6fa90b789c",
      "question": "What are the leasing office hours at Artistry at Bethesda Park?",
      "answer": "The Artistry at Bethesda Park leasing office is open during these hours:\n\n• Monday: 9:00 AM to 6:00 PM\n• Tuesday: 9:00 AM to 6:00 PM\n• Wednesday: 9:00 AM to 6:00 PM\n• Thursday: 9:00 AM to 6:00 PM\n• Friday: 9:00 AM to 6:00 PM\n• Saturday: 10:00 AM to 5:00 PM\n\nHours may change around holidays. Call (770) 921-7794 or visit our contact page to confirm before you visit.",
      "category": "Office Hours",
      "source": "custom"
    },
    {
      "id": "custom_29f6a911-381d-47e0-a8d4-c8d652e23cf6",
      "question": "What floor plans are available at Artistry at Bethesda Park?",
      "answer": "Artistry at Bethesda Park offers 1- to 3-bedroom apartment homes ranging from approximately 840 to 1,492 square feet, across 6 floor plans. View layouts, square footage, and current availability on our Floor Plans page, or schedule a tour to see them in person.",
      "category": "Floor Plans & Units",
      "source": "custom"
    },
    {
      "id": "custom_88de185a-de85-4a23-aae7-bc6701f603ad",
      "question": "What amenities does Artistry at Bethesda Park have?",
      "answer": "Artistry at Bethesda Park offers a range of community and in-home amenities. Community amenities include: American Landmark 360, Courtyard, Dog Park, Dog Spa, Fire Pit, Fitness Center, Game Room, Online Resident Services, Package System, Pool, and Select Homes. In-home features include: blinds, counters, fire, hard floors, kitchen appliances, outside space, pantry closets, tile backsplash, usb outlet, and w&d included. See the complete list on our Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_da694152-eb53-4e1c-a606-01698c5e4794",
      "question": "Where is Artistry at Bethesda Park located?",
      "answer": "Artistry at Bethesda Park is located at 156 Bethesda Church Rd, Lawrenceville GA 30044. Nearby you'll find dining at The Catfe, shopping at Walmart Supercenter, and green space at Bethesda Park & Aquatic Center. Explore more on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    },
    {
      "id": "custom_5938dc13-8197-428b-a206-6127244927b5",
      "question": "How do I apply to live at Artistry at Bethesda Park?",
      "answer": "You can apply to live at Artistry at Bethesda Park online through our Apply Now page, which walks you through each step. If you have questions, the leasing team can help. Call (770) 921-7794 or reach out through our contact page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_d31bb99c-94b8-4a88-9582-34946aa08928",
      "question": "What do I need to apply at Artistry at Bethesda Park?",
      "answer": "Applicants should be ready to provide standard rental application information, including government-issued identification, proof of income, and rental history. Qualification requirements can vary, so we recommend confirming the current criteria with the Artistry at Bethesda Park leasing team at (770) 921-7794 or on our contact page. When you're ready, start on the Apply Now page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_d8019444-c094-4977-81d4-ff9660bafff3",
      "question": "What is the Landmark 360 program at Artistry at Bethesda Park?",
      "answer": "Artistry at Bethesda Park participates in American Landmark's Landmark 360 resident program, which includes three resident promises:\n\n• Move-In Satisfaction Promise: if you are not satisfied within your first 15 days, American Landmark will refund your deposit and waive lease-termination fees.\n• 48-Hour Maintenance Completion Promise: work orders are completed within 48 hours (Monday through Friday), with rent credits if that timeline is missed.\n• Relocation Promise: after six months on your lease, you can transfer to another American Landmark community without penalties, with 60 days' written notice.\nTo learn more, contact the leasing team at (770) 921-7794 or visit our contact page.",
      "category": "Resident Programs",
      "source": "custom"
    },
    {
      "id": "custom_c9bca927-2bdc-4d9c-a3b9-d7f01f53e1db",
      "question": "Does Artistry at Bethesda Park have a pool?",
      "answer": "Yes. Artistry at Bethesda Park has a swimming pool for residents. See it alongside our other community amenities on the Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_cd95db1a-c873-4a36-b28f-bac7215d1786",
      "question": "Does Artistry at Bethesda Park have a fitness center?",
      "answer": "Yes. Artistry at Bethesda Park has a fitness center for residents. See all amenities on the Amenities page, or schedule a tour to view it in person.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_72201d8a-7bfa-4ab6-8b13-236ead3ab925",
      "question": "Does Artistry at Bethesda Park have a dog park?",
      "answer": "Yes. Artistry at Bethesda Park has an on-site dog park for residents and their dogs. See more community amenities on the Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_779c6053-d34d-4360-a95c-8380746c3153",
      "question": "Does Artistry at Bethesda Park offer virtual tours?",
      "answer": "Yes. Artistry at Bethesda Park offers virtual tours of Artistry At Bethesda. Start on our Virtual Tours page, then schedule an in-person tour when you are ready.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_65650fe3-1e62-4828-8ecc-4c214acf5dce",
      "question": "What do residents say about living at Artistry at Bethesda Park?",
      "answer": "Residents frequently mention the helpful staff and responsive maintenance at Artistry at Bethesda Park. One resident wrote: *\"Living at Artistry at Bethesda has been a great experience. The maintenance team is super responsive, professional, and always gets things handled quickly.\"* Read more resident reviews on our Reviews page.",
      "category": "Resident Life",
      "source": "custom"
    },
    {
      "id": "custom_39073805-9829-4db5-82a1-178bfdde9bda",
      "question": "When was Artistry at Bethesda Park built?",
      "answer": "Artistry at Bethesda Park was built in 2001 and renovated in 2021. Schedule a tour to see the finishes in person.",
      "category": "Property History & Features",
      "source": "custom"
    },
    {
      "id": "custom_7c4223e3-b474-4cb0-b24b-09c7a81c5316",
      "question": "What is the pet fee at Artistry at Bethesda Park?",
      "answer": "Pets at Artistry at Bethesda Park: cats and dogs are welcome, up to 2 per home, with no posted weight limit. Some breed restrictions apply. Assistance animals (service animals and emotional support animals) are not pets under fair housing law, so they are not subject to pet fees, deposits, or breed and weight restrictions. For details, contact the leasing team at (770) 921-7794 or visit our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_9433142d-c631-4bd6-9e6d-8ce096e055fe",
      "question": "What features are included in the apartments at Artistry at Bethesda Park?",
      "answer": "Apartment homes at Artistry at Bethesda Park include blinds, counters, fire, hard floors, kitchen appliances, outside space, pantry closets, tile backsplash, usb outlet, and w&d included. Browse layouts on our Floor Plans page or schedule a tour.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_0e33df90-fe8e-4c07-9657-a2a2db2eb927",
      "question": "What restaurants and shops are near Artistry at Bethesda Park?",
      "answer": "Nearby restaurants and shops include The Catfe, Mei Garden, Monterrey Restaurante Mexicano, and Mi Bella Colombia. See the full neighborhood guide on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-2b18-7456-a577-dfcac4fb690d",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "artistry-at-bethesda-park",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496"
    },
    {
      "lead_collector_id": "0198aa45-2b7b-74da-94e5-1e398055f6ae",
      "lead_source": "FACEBOOK_ADS",
      "name": "artistry-at-bethesda-park",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496"
    },
    {
      "lead_collector_id": "0198aa45-2bde-707a-8039-0d0b90b86e40",
      "lead_source": "LANDING_PAGE",
      "name": "artistry-at-bethesda-park",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-for-rent-lawrenceville-ga",
      "search_query": "One Bedroom Apartments For Rent In Lawrenceville GA",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments For Rent In Lawrenceville GA",
      "h2_subtitle": "Discover luxury and comfort at Artistry at Bethesda Park. Our one-bedroom apartments offer modern amenities in a serene setting.",
      "page_copy": "Surround yourself with beauty at Artistry at Bethesda Park. Our one-bedroom apartments for rent in Lawrenceville, GA, feature open-concept layouts, stainless steel appliances, and private patios or balconies. Enjoy the convenience of a washer/dryer, air conditioning, and hardwood floors. Our gated community offers resort-style amenities, including a shimmering swimming pool, lighted tennis courts, and a fully-equipped fitness center. Located just steps from Bethesda Park and 30 minutes from downtown Atlanta, Artistry at Bethesda Park is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f6c0b-76c9-7399-ba8a-f65d9fc516d8.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of an apartment building with balconies and windows.",
        "public_id": "019f6c0b-76c9-7399-ba8a-f65d9fc516d8",
        "storage_key": "property/5670511623274496/019f6c0b-76c9-7399-ba8a-f65d9fc516d8.webp",
        "width": 800,
        "height": 533
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f6c0b-7de5-71b8-a5b1-b83ed4e36f25.webp",
      "blank_image_media": {
        "alt_text": "Black background image",
        "public_id": "019f6c0b-7de5-71b8-a5b1-b83ed4e36f25",
        "storage_key": "property/5670511623274496/019f6c0b-7de5-71b8-a5b1-b83ed4e36f25.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Artistry at Bethesda Park | One Bedroom Apartments For Rent In Lawrenceville GA",
      "seo_description": "Find luxury one-bedroom apartments for rent in Lawrenceville, GA at Artistry at Bethesda Park. Enjoy modern amenities and a serene setting near Bethesda Park.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "custom",
      "page_item_url": "two-bedrooms-apartments-for-rent-lawrenceville-ga",
      "search_query": "Two Bedrooms Apartments For Rent In Lawrenceville GA",
      "category": "Floorplan",
      "h1_title": "Two Bedrooms Apartments For Rent In Lawrenceville GA",
      "h2_subtitle": "Experience the perfect blend of luxury and comfort at Artistry at Bethesda Park. Our two-bedroom apartments offer modern amenities in a serene environment.",
      "page_copy": "Surround yourself with beauty at Artistry at Bethesda Park. Our two bedrooms apartments for rent in Lawrenceville, GA, feature spacious layouts, stainless steel appliances, and private patios or balconies. Enjoy the convenience of a washer/dryer, air conditioning, and hardwood floors. Our gated community offers resort-style amenities, including a shimmering swimming pool, lighted tennis courts, and a fully-equipped fitness center. Located just steps from Bethesda Park and 30 minutes from downtown Atlanta, Artistry at Bethesda Park is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f6c0b-76c9-7399-ba8a-f65d9fc516d8.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of an apartment building with balconies and windows.",
        "public_id": "019f6c0b-76c9-7399-ba8a-f65d9fc516d8",
        "storage_key": "property/5670511623274496/019f6c0b-76c9-7399-ba8a-f65d9fc516d8.webp",
        "width": 800,
        "height": 533
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f6c0b-7de5-71b8-a5b1-b83ed4e36f25.webp",
      "blank_image_media": {
        "alt_text": "Black background image",
        "public_id": "019f6c0b-7de5-71b8-a5b1-b83ed4e36f25",
        "storage_key": "property/5670511623274496/019f6c0b-7de5-71b8-a5b1-b83ed4e36f25.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Artistry at Bethesda Park | Two Bedrooms Apartments For Rent In Lawrenceville GA",
      "seo_description": "Find luxury two bedrooms apartments for rent in Lawrenceville, GA at Artistry at Bethesda Park. Enjoy modern amenities and a serene setting near Bethesda Park.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "custom",
      "page_item_url": "three-bedrooms-apartments-for-rent-lawrenceville-ga",
      "search_query": "Three Bedrooms Apartments For Rent In Lawrenceville GA",
      "category": "Floorplan",
      "h1_title": "Three Bedrooms Apartments For Rent In Lawrenceville GA",
      "h2_subtitle": "Discover spacious living at Artistry at Bethesda Park. Our three-bedroom apartments offer modern amenities and a serene environment.",
      "page_copy": "Surround yourself with beauty at Artistry at Bethesda Park. Our three bedrooms apartments for rent in Lawrenceville, GA, feature expansive layouts, stainless steel appliances, and private patios or balconies. Enjoy the convenience of a washer/dryer, air conditioning, and hardwood floors. Our gated community offers resort-style amenities, including a shimmering swimming pool, lighted tennis courts, and a fully-equipped fitness center. Located just steps from Bethesda Park and 30 minutes from downtown Atlanta, Artistry at Bethesda Park is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f6c0b-76c9-7399-ba8a-f65d9fc516d8.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of an apartment building with balconies and windows.",
        "public_id": "019f6c0b-76c9-7399-ba8a-f65d9fc516d8",
        "storage_key": "property/5670511623274496/019f6c0b-76c9-7399-ba8a-f65d9fc516d8.webp",
        "width": 800,
        "height": 533
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f6c0b-7de5-71b8-a5b1-b83ed4e36f25.webp",
      "blank_image_media": {
        "alt_text": "Black background image",
        "public_id": "019f6c0b-7de5-71b8-a5b1-b83ed4e36f25",
        "storage_key": "property/5670511623274496/019f6c0b-7de5-71b8-a5b1-b83ed4e36f25.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Artistry at Bethesda Park | Three Bedrooms Apartments For Rent In Lawrenceville GA",
      "seo_description": "Find luxury three bedrooms apartments for rent in Lawrenceville, GA at Artistry at Bethesda Park. Enjoy modern amenities and a serene setting near Bethesda Park.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-pool",
      "search_query": "Apartments For Rent Near Me with Pool",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Pool",
      "h2_subtitle": "Enjoy resort-style living at Artistry at Bethesda Park. Our apartments feature modern amenities and a shimmering swimming pool.",
      "page_copy": "Surround yourself with beauty at Artistry at Bethesda Park. Our apartments for rent near me with pool offer a serene environment and modern amenities. Enjoy spacious layouts, stainless steel appliances, and private patios or balconies. Our gated community features a shimmering swimming pool, lighted tennis courts, and a fully-equipped fitness center. Located just steps from Bethesda Park and 30 minutes from downtown Atlanta, Artistry at Bethesda Park is the perfect place to call home. Experience luxury and comfort in our one, two, and three-bedroom apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f6c0b-76c9-7399-ba8a-f65d9fc516d8.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of an apartment building with balconies and windows.",
        "public_id": "019f6c0b-76c9-7399-ba8a-f65d9fc516d8",
        "storage_key": "property/5670511623274496/019f6c0b-76c9-7399-ba8a-f65d9fc516d8.webp",
        "width": 800,
        "height": 533
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f6c0b-7de5-71b8-a5b1-b83ed4e36f25.webp",
      "blank_image_media": {
        "alt_text": "Black background image",
        "public_id": "019f6c0b-7de5-71b8-a5b1-b83ed4e36f25",
        "storage_key": "property/5670511623274496/019f6c0b-7de5-71b8-a5b1-b83ed4e36f25.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Artistry at Bethesda Park | Apartments For Rent Near Me with Pool",
      "seo_description": "Find apartments for rent near me with pool at Artistry at Bethesda Park. Enjoy modern amenities and a serene setting near Bethesda Park in Lawrenceville, GA.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-fitness-center",
      "search_query": "Apartments For Rent Near Me with Fitness Center",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Fitness Center",
      "h2_subtitle": "Experience luxury living at Artistry at Bethesda Park. Our apartments feature modern amenities and a fully-equipped fitness center.",
      "page_copy": "Surround yourself with beauty at Artistry at Bethesda Park. Our apartments for rent near me with fitness center offer a serene environment and modern amenities. Enjoy spacious layouts, stainless steel appliances, and private patios or balconies. Our gated community features a fully-equipped fitness center, shimmering swimming pool, and lighted tennis courts. Located just steps from Bethesda Park and 30 minutes from downtown Atlanta, Artistry at Bethesda Park is the perfect place to call home. Experience luxury and comfort in our one, two, and three-bedroom apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f6c0b-76c9-7399-ba8a-f65d9fc516d8.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of an apartment building with balconies and windows.",
        "public_id": "019f6c0b-76c9-7399-ba8a-f65d9fc516d8",
        "storage_key": "property/5670511623274496/019f6c0b-76c9-7399-ba8a-f65d9fc516d8.webp",
        "width": 800,
        "height": 533
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f6c0b-7de5-71b8-a5b1-b83ed4e36f25.webp",
      "blank_image_media": {
        "alt_text": "Black background image",
        "public_id": "019f6c0b-7de5-71b8-a5b1-b83ed4e36f25",
        "storage_key": "property/5670511623274496/019f6c0b-7de5-71b8-a5b1-b83ed4e36f25.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Artistry at Bethesda Park | Apartments For Rent Near Me with Fitness Center",
      "seo_description": "Find apartments for rent near me with fitness center at Artistry at Bethesda Park. Enjoy modern amenities and a serene setting near Bethesda Park in Lawrenceville, GA.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-pet-play-area",
      "search_query": "Apartments For Rent Near Me with Pet Play Area",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Pet Play Area",
      "h2_subtitle": "Discover pet-friendly living at Artistry at Bethesda Park. Our apartments feature modern amenities and a dedicated pet play area.",
      "page_copy": "Surround yourself with beauty at Artistry at Bethesda Park. Our apartments for rent near me with pet play area offer a serene environment and modern amenities. Enjoy spacious layouts, stainless steel appliances, and private patios or balconies. Our gated community features a dedicated pet play area, shimmering swimming pool, and a fully-equipped fitness center. Located just steps from Bethesda Park and 30 minutes from downtown Atlanta, Artistry at Bethesda Park is the perfect place to call home. Experience luxury and comfort in our one, two, and three-bedroom apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f6c0b-76c9-7399-ba8a-f65d9fc516d8.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of an apartment building with balconies and windows.",
        "public_id": "019f6c0b-76c9-7399-ba8a-f65d9fc516d8",
        "storage_key": "property/5670511623274496/019f6c0b-76c9-7399-ba8a-f65d9fc516d8.webp",
        "width": 800,
        "height": 533
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f6c0b-7de5-71b8-a5b1-b83ed4e36f25.webp",
      "blank_image_media": {
        "alt_text": "Black background image",
        "public_id": "019f6c0b-7de5-71b8-a5b1-b83ed4e36f25",
        "storage_key": "property/5670511623274496/019f6c0b-7de5-71b8-a5b1-b83ed4e36f25.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Artistry at Bethesda Park | Apartments For Rent Near Me with Pet Play Area",
      "seo_description": "Find apartments for rent near me with pet play area at Artistry at Bethesda Park. Enjoy modern amenities and a serene setting near Bethesda Park in Lawrenceville, GA.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-sundeck",
      "search_query": "Apartments For Rent Near Me with Sundeck",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Sundeck",
      "h2_subtitle": "Experience luxury living at Artistry at Bethesda Park. Our apartments feature modern amenities and a relaxing sundeck.",
      "page_copy": "Surround yourself with beauty at Artistry at Bethesda Park. Our apartments for rent near me with sundeck offer a serene environment and modern amenities. Enjoy spacious layouts, stainless steel appliances, and private patios or balconies. Our gated community features a relaxing sundeck, shimmering swimming pool, and a fully-equipped fitness center. Located just steps from Bethesda Park and 30 minutes from downtown Atlanta, Artistry at Bethesda Park is the perfect place to call home. Experience luxury and comfort in our one, two, and three-bedroom apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f6c0b-76c9-7399-ba8a-f65d9fc516d8.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of an apartment building with balconies and windows.",
        "public_id": "019f6c0b-76c9-7399-ba8a-f65d9fc516d8",
        "storage_key": "property/5670511623274496/019f6c0b-76c9-7399-ba8a-f65d9fc516d8.webp",
        "width": 800,
        "height": 533
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f6c0b-7de5-71b8-a5b1-b83ed4e36f25.webp",
      "blank_image_media": {
        "alt_text": "Black background image",
        "public_id": "019f6c0b-7de5-71b8-a5b1-b83ed4e36f25",
        "storage_key": "property/5670511623274496/019f6c0b-7de5-71b8-a5b1-b83ed4e36f25.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Artistry at Bethesda Park | Apartments For Rent Near Me with Sundeck",
      "seo_description": "Find apartments for rent near me with sundeck at Artistry at Bethesda Park. Enjoy modern amenities and a serene setting near Bethesda Park in Lawrenceville, GA.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-grill",
      "search_query": "Apartments For Rent Near Me with Grill",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Grill",
      "h2_subtitle": "Enjoy luxury living at Artistry at Bethesda Park. Our apartments feature modern amenities and a community grill area.",
      "page_copy": "Surround yourself with beauty at Artistry at Bethesda Park. Our apartments for rent near me with grill offer a serene environment and modern amenities. Enjoy spacious layouts, stainless steel appliances, and private patios or balconies. Our gated community features a community grill area, shimmering swimming pool, and a fully-equipped fitness center. Located just steps from Bethesda Park and 30 minutes from downtown Atlanta, Artistry at Bethesda Park is the perfect place to call home. Experience luxury and comfort in our one, two, and three-bedroom apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f6c0b-76c9-7399-ba8a-f65d9fc516d8.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of an apartment building with balconies and windows.",
        "public_id": "019f6c0b-76c9-7399-ba8a-f65d9fc516d8",
        "storage_key": "property/5670511623274496/019f6c0b-76c9-7399-ba8a-f65d9fc516d8.webp",
        "width": 800,
        "height": 533
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f6c0b-7de5-71b8-a5b1-b83ed4e36f25.webp",
      "blank_image_media": {
        "alt_text": "Black background image",
        "public_id": "019f6c0b-7de5-71b8-a5b1-b83ed4e36f25",
        "storage_key": "property/5670511623274496/019f6c0b-7de5-71b8-a5b1-b83ed4e36f25.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Artistry at Bethesda Park | Apartments For Rent Near Me with Grill",
      "seo_description": "Find apartments for rent near me with grill at Artistry at Bethesda Park. Enjoy modern amenities and a serene setting near Bethesda Park in Lawrenceville, GA.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-kitchen",
      "search_query": "Apartments For Rent Near Me with Kitchen",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Kitchen",
      "h2_subtitle": "Discover modern living at Artistry at Bethesda Park. Our apartments feature state-of-the-art kitchens and luxurious amenities.",
      "page_copy": "Surround yourself with beauty at Artistry at Bethesda Park. Our apartments for rent near me with kitchen offer a serene environment and modern amenities. Enjoy spacious layouts, stainless steel appliances, and private patios or balconies. Our gated community features state-of-the-art kitchens with granite or quartz countertops, island kitchens, and all the appliances you need. Located just steps from Bethesda Park and 30 minutes from downtown Atlanta, Artistry at Bethesda Park is the perfect place to call home. Experience luxury and comfort in our one, two, and three-bedroom apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f6c0b-76c9-7399-ba8a-f65d9fc516d8.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of an apartment building with balconies and windows.",
        "public_id": "019f6c0b-76c9-7399-ba8a-f65d9fc516d8",
        "storage_key": "property/5670511623274496/019f6c0b-76c9-7399-ba8a-f65d9fc516d8.webp",
        "width": 800,
        "height": 533
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f6c0b-7de5-71b8-a5b1-b83ed4e36f25.webp",
      "blank_image_media": {
        "alt_text": "Black background image",
        "public_id": "019f6c0b-7de5-71b8-a5b1-b83ed4e36f25",
        "storage_key": "property/5670511623274496/019f6c0b-7de5-71b8-a5b1-b83ed4e36f25.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Artistry at Bethesda Park | Apartments For Rent Near Me with Kitchen",
      "seo_description": "Find apartments for rent near me with kitchen at Artistry at Bethesda Park. Enjoy modern amenities and a serene setting near Bethesda Park in Lawrenceville, GA.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-granite-countertops",
      "search_query": "Apartments For Rent Near Me with Granite Countertops",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Granite Countertops",
      "h2_subtitle": "Experience luxury living at Artistry at Bethesda Park. Our apartments feature modern kitchens with granite countertops and upscale amenities.",
      "page_copy": "Surround yourself with beauty at Artistry at Bethesda Park. Our apartments for rent near me with granite countertops offer a serene environment and modern amenities. Enjoy spacious layouts, stainless steel appliances, and private patios or balconies. Our gated community features kitchens with elegant granite countertops, island kitchens, and all the appliances you need. Located just steps from Bethesda Park and 30 minutes from downtown Atlanta, Artistry at Bethesda Park is the perfect place to call home. Experience luxury and comfort in our one, two, and three-bedroom apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f6c0b-76c9-7399-ba8a-f65d9fc516d8.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of an apartment building with balconies and windows.",
        "public_id": "019f6c0b-76c9-7399-ba8a-f65d9fc516d8",
        "storage_key": "property/5670511623274496/019f6c0b-76c9-7399-ba8a-f65d9fc516d8.webp",
        "width": 800,
        "height": 533
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f6c0b-7de5-71b8-a5b1-b83ed4e36f25.webp",
      "blank_image_media": {
        "alt_text": "Black background image",
        "public_id": "019f6c0b-7de5-71b8-a5b1-b83ed4e36f25",
        "storage_key": "property/5670511623274496/019f6c0b-7de5-71b8-a5b1-b83ed4e36f25.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Artistry at Bethesda Park | Apartments For Rent Near Me with Granite Countertops",
      "seo_description": "Find apartments for rent near me with granite countertops at Artistry at Bethesda Park. Enjoy modern amenities and a serene setting near Bethesda Park in Lawrenceville, GA.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-quartz-countertops",
      "search_query": "Apartments For Rent Near Me with Quartz Countertops",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Quartz Countertops",
      "h2_subtitle": "Discover upscale living at Artistry at Bethesda Park. Our apartments feature modern kitchens with quartz countertops and luxurious amenities.",
      "page_copy": "Surround yourself with beauty at Artistry at Bethesda Park. Our apartments for rent near me with quartz countertops offer a serene environment and modern amenities. Enjoy spacious layouts, stainless steel appliances, and private patios or balconies. Our gated community features kitchens with elegant quartz countertops, island kitchens, and all the appliances you need. Located just steps from Bethesda Park and 30 minutes from downtown Atlanta, Artistry at Bethesda Park is the perfect place to call home. Experience luxury and comfort in our one, two, and three-bedroom apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f6c0b-76c9-7399-ba8a-f65d9fc516d8.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of an apartment building with balconies and windows.",
        "public_id": "019f6c0b-76c9-7399-ba8a-f65d9fc516d8",
        "storage_key": "property/5670511623274496/019f6c0b-76c9-7399-ba8a-f65d9fc516d8.webp",
        "width": 800,
        "height": 533
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f6c0b-7de5-71b8-a5b1-b83ed4e36f25.webp",
      "blank_image_media": {
        "alt_text": "Black background image",
        "public_id": "019f6c0b-7de5-71b8-a5b1-b83ed4e36f25",
        "storage_key": "property/5670511623274496/019f6c0b-7de5-71b8-a5b1-b83ed4e36f25.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Artistry at Bethesda Park | Apartments For Rent Near Me with Quartz Countertops",
      "seo_description": "Find apartments for rent near me with quartz countertops at Artistry at Bethesda Park. Enjoy modern amenities and a serene setting near Bethesda Park in Lawrenceville, GA.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-stainless-steel",
      "search_query": "Apartments For Rent Near Me with Stainless Steel Appliances",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Stainless Steel Appliances",
      "h2_subtitle": "Experience modern living at Artistry at Bethesda Park. Our apartments feature state-of-the-art kitchens with stainless steel appliances and luxurious amenities.",
      "page_copy": "Surround yourself with beauty at Artistry at Bethesda Park. Our apartments for rent near me with stainless steel appliances offer a serene environment and modern amenities. Enjoy spacious layouts, stainless steel appliances, and private patios or balconies. Our gated community features kitchens with top-of-the-line stainless steel appliances, island kitchens, and all the appliances you need. Located just steps from Bethesda Park and 30 minutes from downtown Atlanta, Artistry at Bethesda Park is the perfect place to call home. Experience luxury and comfort in our one, two, and three-bedroom apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f6c0b-76c9-7399-ba8a-f65d9fc516d8.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of an apartment building with balconies and windows.",
        "public_id": "019f6c0b-76c9-7399-ba8a-f65d9fc516d8",
        "storage_key": "property/5670511623274496/019f6c0b-76c9-7399-ba8a-f65d9fc516d8.webp",
        "width": 800,
        "height": 533
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f6c0b-7de5-71b8-a5b1-b83ed4e36f25.webp",
      "blank_image_media": {
        "alt_text": "Black background image",
        "public_id": "019f6c0b-7de5-71b8-a5b1-b83ed4e36f25",
        "storage_key": "property/5670511623274496/019f6c0b-7de5-71b8-a5b1-b83ed4e36f25.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Artistry at Bethesda Park | Apartments For Rent Near Me with Stainless Steel Appliances",
      "seo_description": "Find apartments for rent near me with stainless steel appliances at Artistry at Bethesda Park. Enjoy modern amenities and a serene setting near Bethesda Park in Lawrenceville, GA.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-island-kitchen",
      "search_query": "Apartments For Rent Near Me with Island Kitchen",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Island Kitchen",
      "h2_subtitle": "Discover modern living at Artistry at Bethesda Park. Our apartments feature luxurious island kitchens and upscale amenities.",
      "page_copy": "Surround yourself with beauty at Artistry at Bethesda Park. Our apartments for rent near me with island kitchen offer a serene environment and modern amenities. Enjoy spacious layouts, stainless steel appliances, and private patios or balconies. Our gated community features kitchens with elegant island kitchens, granite or quartz countertops, and all the appliances you need. Located just steps from Bethesda Park and 30 minutes from downtown Atlanta, Artistry at Bethesda Park is the perfect place to call home. Experience luxury and comfort in our one, two, and three-bedroom apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f6c0b-76c9-7399-ba8a-f65d9fc516d8.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of an apartment building with balconies and windows.",
        "public_id": "019f6c0b-76c9-7399-ba8a-f65d9fc516d8",
        "storage_key": "property/5670511623274496/019f6c0b-76c9-7399-ba8a-f65d9fc516d8.webp",
        "width": 800,
        "height": 533
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f6c0b-7de5-71b8-a5b1-b83ed4e36f25.webp",
      "blank_image_media": {
        "alt_text": "Black background image",
        "public_id": "019f6c0b-7de5-71b8-a5b1-b83ed4e36f25",
        "storage_key": "property/5670511623274496/019f6c0b-7de5-71b8-a5b1-b83ed4e36f25.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Artistry at Bethesda Park | Apartments For Rent Near Me with Island Kitchen",
      "seo_description": "Find apartments for rent near me with island kitchen at Artistry at Bethesda Park. Enjoy modern amenities and a serene setting near Bethesda Park in Lawrenceville, GA.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "custom",
      "page_item_url": "apartments-for-rent-lawrenceville-ga-near-publix",
      "search_query": "Apartments For Rent In Lawrenceville GA Near Publix Pharmacy at Presidential Markets",
      "category": "POI",
      "h1_title": "Apartments For Rent In Lawrenceville GA Near Publix Pharmacy at Presidential Markets",
      "h2_subtitle": "Discover luxury living at Artistry at Bethesda Park. Our apartments offer modern amenities and are conveniently located near Publix Pharmacy at Presidential Markets.",
      "page_copy": "Surround yourself with beauty at Artistry at Bethesda Park. Our apartments for rent in Lawrenceville, GA near Publix Pharmacy at Presidential Markets offer a serene environment and modern amenities. Enjoy spacious layouts, stainless steel appliances, and private patios or balconies. Our gated community features a shimmering swimming pool, fully-equipped fitness center, and pet play area. Located just steps from Bethesda Park and 30 minutes from downtown Atlanta, Artistry at Bethesda Park is the perfect place to call home. Experience luxury and comfort in our one, two, and three-bedroom apartments, all within close proximity to Publix Pharmacy at Presidential Markets, where you can fill prescriptions, shop for over-the-counter medications, and receive patient counseling.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f6c0b-76c9-7399-ba8a-f65d9fc516d8.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of an apartment building with balconies and windows.",
        "public_id": "019f6c0b-76c9-7399-ba8a-f65d9fc516d8",
        "storage_key": "property/5670511623274496/019f6c0b-76c9-7399-ba8a-f65d9fc516d8.webp",
        "width": 800,
        "height": 533
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f6c0b-7de5-71b8-a5b1-b83ed4e36f25.webp",
      "blank_image_media": {
        "alt_text": "Black background image",
        "public_id": "019f6c0b-7de5-71b8-a5b1-b83ed4e36f25",
        "storage_key": "property/5670511623274496/019f6c0b-7de5-71b8-a5b1-b83ed4e36f25.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Artistry at Bethesda Park | Apartments For Rent In Lawrenceville GA Near Publix Pharmacy at Presidential Markets",
      "seo_description": "Find apartments for rent in Lawrenceville, GA near Publix Pharmacy at Presidential Markets at Artistry at Bethesda Park. Enjoy modern amenities and a serene setting near Bethesda Park.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "custom",
      "page_item_url": "apartments-for-rent-lawrenceville-ga-near-ggc",
      "search_query": "Apartments For Rent In Lawrenceville GA Near Georgia Gwinnett College",
      "category": "POI",
      "h1_title": "Apartments For Rent In Lawrenceville GA Near Georgia Gwinnett College",
      "h2_subtitle": "Experience luxury living at Artistry at Bethesda Park. Our apartments offer modern amenities and are conveniently located near Georgia Gwinnett College.",
      "page_copy": "Surround yourself with beauty at Artistry at Bethesda Park. Our apartments for rent in Lawrenceville, GA near Georgia Gwinnett College offer a serene environment and modern amenities. Enjoy spacious layouts, stainless steel appliances, and private patios or balconies. Our gated community features a shimmering swimming pool, fully-equipped fitness center, and pet play area. Located just steps from Bethesda Park and 30 minutes from downtown Atlanta, Artistry at Bethesda Park is the perfect place to call home. Experience luxury and comfort in our one, two, and three-bedroom apartments, all within close proximity to Georgia Gwinnett College, providing a convenient living option for students and faculty.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f6c0b-76c9-7399-ba8a-f65d9fc516d8.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of an apartment building with balconies and windows.",
        "public_id": "019f6c0b-76c9-7399-ba8a-f65d9fc516d8",
        "storage_key": "property/5670511623274496/019f6c0b-76c9-7399-ba8a-f65d9fc516d8.webp",
        "width": 800,
        "height": 533
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f6c0b-7de5-71b8-a5b1-b83ed4e36f25.webp",
      "blank_image_media": {
        "alt_text": "Black background image",
        "public_id": "019f6c0b-7de5-71b8-a5b1-b83ed4e36f25",
        "storage_key": "property/5670511623274496/019f6c0b-7de5-71b8-a5b1-b83ed4e36f25.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Artistry at Bethesda Park | Apartments For Rent In Lawrenceville GA Near Georgia Gwinnett College",
      "seo_description": "Find apartments for rent in Lawrenceville, GA near Georgia Gwinnett College at Artistry at Bethesda Park. Enjoy modern amenities and a serene setting near Bethesda Park.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "custom",
      "page_item_url": "apartments-for-rent-lawrenceville-ga-near-gsu-perimeter",
      "search_query": "Apartments For Rent In Lawrenceville GA Near Georgia State University: Perimeter College - Dunwoody Campus",
      "category": "POI",
      "h1_title": "Apartments For Rent In Lawrenceville GA Near Georgia State University: Perimeter College - Dunwoody Campus",
      "h2_subtitle": "Discover luxury living at Artistry at Bethesda Park. Our apartments offer modern amenities and are conveniently located near Georgia State University: Perimeter College - Dunwoody Campus.",
      "page_copy": "Surround yourself with beauty at Artistry at Bethesda Park. Our apartments for rent in Lawrenceville, GA near Georgia State University: Perimeter College - Dunwoody Campus offer a serene environment and modern amenities. Enjoy spacious layouts, stainless steel appliances, and private patios or balconies. Our gated community features a shimmering swimming pool, fully-equipped fitness center, and pet play area. Located just steps from Bethesda Park and 30 minutes from downtown Atlanta, Artistry at Bethesda Park is the perfect place to call home. Experience luxury and comfort in our one, two, and three-bedroom apartments, all within close proximity to Georgia State University: Perimeter College - Dunwoody Campus, providing a convenient living option for students and faculty.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f6c0b-76c9-7399-ba8a-f65d9fc516d8.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of an apartment building with balconies and windows.",
        "public_id": "019f6c0b-76c9-7399-ba8a-f65d9fc516d8",
        "storage_key": "property/5670511623274496/019f6c0b-76c9-7399-ba8a-f65d9fc516d8.webp",
        "width": 800,
        "height": 533
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f6c0b-7de5-71b8-a5b1-b83ed4e36f25.webp",
      "blank_image_media": {
        "alt_text": "Black background image",
        "public_id": "019f6c0b-7de5-71b8-a5b1-b83ed4e36f25",
        "storage_key": "property/5670511623274496/019f6c0b-7de5-71b8-a5b1-b83ed4e36f25.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Artistry at Bethesda Park | Apartments For Rent In Lawrenceville GA Near Georgia State University: Perimeter College - Dunwoody Campus",
      "seo_description": "Find apartments for rent in Lawrenceville, GA near Georgia State University: Perimeter College - Dunwoody Campus at Artistry at Bethesda Park. Enjoy modern amenities and a serene setting near Bethesda Park.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "custom",
      "page_item_url": "apartments-for-rent-lawrenceville-ga-near-mcafee-theology",
      "search_query": "Apartments For Rent In Lawrenceville GA Near McAfee School of Theology, Mercer University",
      "category": "POI",
      "h1_title": "Apartments For Rent In Lawrenceville GA Near McAfee School of Theology, Mercer University",
      "h2_subtitle": "Experience luxury living at Artistry at Bethesda Park. Our apartments offer modern amenities and are conveniently located near McAfee School of Theology, Mercer University.",
      "page_copy": "Surround yourself with beauty at Artistry at Bethesda Park. Our apartments for rent in Lawrenceville, GA near McAfee School of Theology, Mercer University offer a serene environment and modern amenities. Enjoy spacious layouts, stainless steel appliances, and private patios or balconies. Our gated community features a shimmering swimming pool, fully-equipped fitness center, and pet play area. Located just steps from Bethesda Park and 30 minutes from downtown Atlanta, Artistry at Bethesda Park is the perfect place to call home. Experience luxury and comfort in our one, two, and three-bedroom apartments, all within close proximity to McAfee School of Theology, Mercer University, providing a convenient living option for students and faculty.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f6c0b-76c9-7399-ba8a-f65d9fc516d8.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of an apartment building with balconies and windows.",
        "public_id": "019f6c0b-76c9-7399-ba8a-f65d9fc516d8",
        "storage_key": "property/5670511623274496/019f6c0b-76c9-7399-ba8a-f65d9fc516d8.webp",
        "width": 800,
        "height": 533
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f6c0b-7de5-71b8-a5b1-b83ed4e36f25.webp",
      "blank_image_media": {
        "alt_text": "Black background image",
        "public_id": "019f6c0b-7de5-71b8-a5b1-b83ed4e36f25",
        "storage_key": "property/5670511623274496/019f6c0b-7de5-71b8-a5b1-b83ed4e36f25.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Artistry at Bethesda Park | Apartments For Rent In Lawrenceville GA Near McAfee School of Theology, Mercer University",
      "seo_description": "Find apartments for rent in Lawrenceville, GA near McAfee School of Theology, Mercer University at Artistry at Bethesda Park. Enjoy modern amenities and a serene setting near Bethesda Park.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5670511623274496",
      "source": "custom",
      "page_item_url": "apartments-for-rent-lawrenceville-ga-near-oglethorpe-university",
      "search_query": "Apartments For Rent In Lawrenceville GA Near Oglethorpe University",
      "category": "POI",
      "h1_title": "Apartments For Rent In Lawrenceville GA Near Oglethorpe University",
      "h2_subtitle": "Experience luxury living at Artistry at Bethesda Park. Our apartments offer modern amenities and are conveniently located near Oglethorpe University.",
      "page_copy": "Surround yourself with beauty at Artistry at Bethesda Park. Our apartments for rent in Lawrenceville, GA near Oglethorpe University offer a serene environment and modern amenities. Enjoy spacious layouts, stainless steel appliances, and private patios or balconies. Our gated community features a shimmering swimming pool, fully-equipped fitness center, and pet play area. Located just steps from Bethesda Park and 30 minutes from downtown Atlanta, Artistry at Bethesda Park is the perfect place to call home. Experience luxury and comfort in our one, two, and three-bedroom apartments, all within close proximity to Oglethorpe University, providing a convenient living option for students and faculty.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f6c0b-76c9-7399-ba8a-f65d9fc516d8.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of an apartment building with balconies and windows.",
        "public_id": "019f6c0b-76c9-7399-ba8a-f65d9fc516d8",
        "storage_key": "property/5670511623274496/019f6c0b-76c9-7399-ba8a-f65d9fc516d8.webp",
        "width": 800,
        "height": 533
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5670511623274496/019f6c0b-7de5-71b8-a5b1-b83ed4e36f25.webp",
      "blank_image_media": {
        "alt_text": "Black background image",
        "public_id": "019f6c0b-7de5-71b8-a5b1-b83ed4e36f25",
        "storage_key": "property/5670511623274496/019f6c0b-7de5-71b8-a5b1-b83ed4e36f25.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Artistry at Bethesda Park | Apartments For Rent In Lawrenceville GA Near Oglethorpe University",
      "seo_description": "Find apartments for rent in Lawrenceville, GA near Oglethorpe University at Artistry at Bethesda Park. Enjoy modern amenities and a serene setting near Bethesda Park.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2139"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2376471063"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a15\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a15\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4881699"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-MW4TLPW"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "1"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443201069"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "11f12cedf81ad217"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/rxwj9850p1e"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/8cd0a84a-c93f-4138-b054-b2413fbc27ba"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "770-824-1523"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InowZE5rNkdWbHh4Tk1UbWZPOE91VVE9PSIsInZhbHVlIjoiMnlIVFRVQ053dDNNZWZrWGFPN0podz09IiwibWFjIjoiODZkYzZjMzJiNTQ1NmU1YjJiMjU0NGEyYWVjZmUzZTNkNTc4Yjg0ZjlmNjJkZDhkMTlmMTUwMzczNjhjNDk4OCJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2139",
  "custom_repli_id": "2376471063",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a15\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a15\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4881699",
  "custom_google_gtm_id": "GTM-MW4TLPW",
  "custom_rollout_phase": "1",
  "custom_ads_subscription": "full_stack",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443201069",
  "custom_knock_community_id": "11f12cedf81ad217",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/rxwj9850p1e",
  "custom_self_guided_tour_url": "https://selftournow.com/property/8cd0a84a-c93f-4138-b054-b2413fbc27ba",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "770-824-1523",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InowZE5rNkdWbHh4Tk1UbWZPOE91VVE9PSIsInZhbHVlIjoiMnlIVFRVQ053dDNNZWZrWGFPN0podz09IiwibWFjIjoiODZkYzZjMzJiNTQ1NmU1YjJiMjU0NGEyYWVjZmUzZTNkNTc4Yjg0ZjlmNjJkZDhkMTlmMTUwMzczNjhjNDk4OCJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "08ff027f-846c-440a-8671-f47099dc1e6f",
  "custom_audioeye_site_hash": "d75dccc0898304786007a3e5cce500bf"
};

export const generatedAt = '2026-11-03T20:39:21.405Z';
